var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import KnockoutModel from "../../lib/knockout_model";
import "../../components/header";
import "../../components/leftMenu";
import "./Myproject.css";
import "../../lib/knockout_pscUpload";
import "../../lib/knockout_datafileUpload";
import '../../lib/knockout_datePicker';
import '../../lib/knockout_fileUpload';
import * as authorization from "../../lib/authorization";
import * as ajax from "../../app-lib/ajax_proxy";
import "../../components/paging";
import '../../assets/css/preview.css';
import preview from '../../lib/preview.js';
import "./fileProgressBar.css";
import * as Configs from "../../app-lib/constants";
import "../../lib/knockout_pscUpload";
import "../../lib/knockout_datafileUpload";
import '../../lib/knockout_datePicker';
import '../../lib/knockout_fileUpload';
// import { Configs } from '../../app-lib/constants';
var Preview = preview;
var BMAP_STATUS_SUCCESS = 0;
var projectid;
var gps;
var fileId;
var fileName;
// let fd = new FormData();//提交文件
var HeaderModel = /** @class */ (function (_super) {
    __extends(HeaderModel, _super);
    function HeaderModel(root) {
        var _this = _super.call(this, "/api/project/pc/screen", root, {}) || this;
        _this.leadurl = ko.observable('/api/ice/conupload');
        _this.money = ko.observable(); //钱数
        _this.precent = ko.observable(); //百分比
        _this.projectfilename = ko.observableArray(); //kexingxing
        _this.auditreport = ko.observableArray(); //审计报告
        _this.Contractandseal = ko.observableArray(); //合同及盖章
        _this.agreement = ko.observableArray(); //股权转让协议
        _this.sercontract = ko.observableArray(); //服务合同
        _this.csfile = ko.observableArray(); //测算文件
        _this.info = ko.observable(); //项目信息
        _this.time = ko.observable(); //聊天时间
        _this.userid = ko.observable(""); //用户id
        _this.massage = ko.observableArray(); //聊天记录
        _this.cooperationMode = ko.observable(); //合作方式
        _this.projectName = ko.observable(); //项目名称
        _this.projectAddr = ko.observable(); //项目地点
        _this.projectArea = ko.observable(); //项目面积
        _this.projectParts = ko.observable(""); //已入伙面积
        _this.partarea = ko.observable(""); //一入伙面积
        _this.sprojectname = ko.observable(); //搜索条件
        _this.providerPhone = ko.observableArray(); //信息提供者电话
        _this.providerName = ko.observableArray(); //信息提供者姓名
        _this.holderName = ko.observable(); //持股名
        _this.holderPercent = ko.observable(); //持股数
        _this.projectBeginTime = ko.observable(); //项目发起时间
        _this.projectStatus = ko.observable(); //项目进度
        _this.projectOwner = ko.observable(); //负责人
        _this.projectInputer = ko.observable(); //发起人
        _this.projectid = ko.observable(); //项目id
        _this.firstParty = ko.observable(""); //合作甲方
        _this.secondparty = ko.observable(""); //合作乙方
        _this.cooperativeNature = ko.observable(); //合作性质
        _this.beginTime = ko.observable(''); //项目进场时间
        _this.serviceTime = ko.observable(''); //合同服务期限
        _this.signTime = ko.observable(''); //签约时间
        _this.signTimes = ko.observable(''); //收购签约时间
        _this.projectCount = ko.observable(); //项目个数
        _this.cid = ko.observable(); //合同id，就是项目id
        _this.projectManager = ko.observable();
        _this.exchangeRights = ko.observable('');
        _this.communityCount = ko.observable(1);
        _this.totalArea = ko.observable(0);
        _this.totalExtract = ko.observable(0);
        _this.holderList = ko.observableArray([{ holderName: "", holderPercent: "" }]); //持股人
        _this.infoList = ko.observableArray([{ communityName: "", builtArea: "", projectCity: "", contractService: "1" }]); //项目资料
        _this.hiddenG = ko.observable(false); //隐藏跟进
        _this.hiddenY = ko.observable(false); //隐藏全委
        _this.hiddenS = ko.observable(false); //隐藏收购
        _this.hiddenH = ko.observable(false); //隐藏核算
        _this.hiddenW = ko.observable(false); //隐藏完成
        _this.hiddenGZ = ko.observable(false); //隐藏关注人
        _this.chan = ko.observable(""); //聊天输入
        _this.prostatus = ko.observable(undefined); //项目状态筛选
        _this.pstatus = ko.observableArray([{ id: 1, text: "全部" }, { id: 7, text: "我负责" }, { id: 2, text: "我关注" }, { id: 3, text: "未跟进" }, { id: 4, text: "确认中" }, { id: 5, text: "已签约" }, { id: 6, text: "已放弃" }]);
        _this.userId = ko.observable();
        _this.XiangXi = ko.observable(0);
        _this.popur = ko.observable(0);
        _this.qunliao = ko.observable(0);
        _this.qunliaox = ko.observable(0);
        _this.genjin = ko.observable(0);
        _this.yeji = ko.observable(0);
        _this.shougou = ko.observable(0);
        _this.shougouLook = ko.observable(0);
        _this.quanweiLook = ko.observable(0);
        _this.saveFolderName = ko.observable(); //当前选择文件夹
        _this.addSign = ko.observable(false); //新增签约
        _this.givememoneymassage = ko.observableArray([{ ser: "", area: "", stands: "" }]); //收费信息1
        _this.givememoneymassagetwo = ko.observableArray([{ stopcar: "", charge: "", chargest: "" }]); //收费信息2
        _this.allocationplan = ko.observableArray([{ name: ko.observable(""), allocationpro: "", remark: "", extiactmoney: ko.observable(0) }]); //全委表单提成分配方案
        _this.Sallocationplan = ko.observableArray([{ name: ko.observable(''), Sallocationpro: "", Sremark: "", Sextiactmoney: ko.observable(0) }]); //收购表单提成分配方案
        _this.username = ko.observableArray(); //参与人id
        _this.susername = ko.observableArray(); //收购参与人id
        _this.project = ko.observable();
        _this.postName = ko.observable();
        _this.qwpostName = ko.observable();
        _this.peopleindex = ko.observable();
        // choose_index = ko.observableArray();//收购关注人
        _this.qwchoose_index = ko.observableArray(); //全委关注人
        _this.projectowner = ko.observable("");
        _this.projectpb = ko.observable("");
        _this.proid = ko.observable("");
        _this.popur1 = ko.observable(0);
        _this.popur2 = ko.observable(0);
        _this.yearchargeone = ko.observable(0);
        _this.yearchargetwo = ko.observable(0);
        _this.yearchargeall = ko.observable(0);
        _this.extiactmoney = ko.observableArray([0]);
        _this.Sextiactmoney = ko.observableArray([0]);
        _this.searchnamevalue = ko.observable();
        _this.qwsearchnamevalue = ko.observable();
        _this.exchange = ko.observable(0); //全委预计提成总额
        _this.pid = ko.observable(); //图片上传pid
        _this.noticername = ko.observable(); //关注人名
        _this.changename = ko.observable(); //关注人搜索
        _this.chosebtn = ko.observable(0);
        _this.uploadReportId = ko.observableArray();
        _this.uploadExamineId = ko.observableArray();
        _this.uploadScanId = ko.observableArray();
        _this.investiagtionReport = ko.observableArray();
        _this.auditReport = ko.observableArray();
        _this.contractApproval = ko.observableArray();
        _this.equityAgreement = ko.observableArray();
        _this.isCan = ko.observable(false); //是否过期
        _this.isSH = ko.observable(false); //是否是审核消息
        _this.moreArr = ko.observableArray(); //显示更多附件 展示数组
        _this.showMore = ko.observable(false);
        _this.sgPname = ko.observable(''); //项目名对比
        _this.dbaddress = ko.observable(''); //项目对比地点
        //洽谈跟进全委表单
        _this.num = ko.observable(); //状态
        _this.qwPname = ko.observable(''); //项目名对比
        _this.htfile = ko.observableArray(); //合同文件
        _this.fwfile = ko.observableArray(); //服务文件
        _this.tyIndex = ko.observable();
        _this.newsType = ko.observable();
        // projectId=ko.observable('');//项目id
        _this.shougouInfo = ko.observable(); // 收购的详细信息
        _this.quanweiInfo = ko.observable(); ///全委的信息
        _this.sreason = ko.observable('');
        _this.greason = ko.observable('');
        _this.fileUploadNumber = ko.observable(''); //文件上传分类标记
        //////////////////////
        //////////下面是文件上传进度条的实现
        _this.popur4 = ko.observable(0);
        // 进度条弹框
        _this.hiddenBodyOne = ko.observable(true);
        _this.hiddenBodytwo = ko.observable(false);
        _this.fileList = ko.observableArray([]); //文件列表
        _this.fileText = ko.observable(''); //文件统计提示
        _this.hiddenBar = ko.observable(false);
        _this.hiddenWord = ko.observable(true);
        _this.hiddenWan = ko.observable(false);
        _this.stime = ko.observable(); //开始时间
        _this.etime = ko.observable(); //结束时间
        _this.localTime = ko.observable(0); //本地上传需要多久
        _this.progressBar = ko.observable(0); //进度条%
        _this.fileData = ko.observableArray(); //上传的文件的ID和name
        // pid = ko.observable('');//文件柜上传id
        // cid = ko.observable('');//表单上传id
        _this.fileUploadUrl = ko.observable(''); //文档上传url
        _this.fileSize = ko.observable(0); //文件大小
        _this.hiddenX = ko.observable(true); //点击删除文件
        _this.newFd = ko.observableArray(); //文件上传对象
        _this.choose_index = ko.observableArray(); //选中的用户
        return _this;
    }
    HeaderModel.prototype.GengDuo = function (index, m, e) {
        var div = e.currentTarget
            .nextElementSibling;
        var trL = this.container.querySelectorAll('.Myproject-list-tr');
        for (var i = 0; i < trL.length; i++) {
            if (trL[i].children[12].children[2].style.display == 'block' && i != index) {
                trL[i].children[12].children[2].style.display = 'none';
            }
        }
        if (!div.style.display || div.style.display == "none") {
            div.style.display = "block";
        }
        else {
            div.style.display = "none";
        }
    };
    HeaderModel.prototype.YeJi = function (m, e) {
        var _this = this;
        this.clearInput();
        this.uploadReportId([]);
        this.uploadExamineId([]);
        this.uploadScanId([]);
        this.csfile([]);
        this.fwfile([]);
        this.htfile([]);
        this.showMore(false);
        this.allocationplan([{ name: ko.observable(""), allocationpro: "", remark: "", extiactmoney: ko.observable(0) }]); //全委表单提成分配方案
        if (this.isCan() == false) {
            return window.popBox.show('公式已过期');
        }
        this.cid(this.projectid());
        if (this.yeji() == 1) {
            this.yeji(0);
        }
        else {
            ajax.get("/api/project/excel", { projectId: this.projectid() })
                .then(function (d) {
                if (d.data) {
                    _this.precent(d.data.rate);
                    _this.projectName(d.data.projectName);
                    _this.qwPname(d.data.projectName);
                    _this.dbaddress(d.data.projectAddr);
                    _this.projectArea(d.data.projectArea);
                    _this.projectAddr(d.data.projectAddr);
                    _this.projectParts(d.data.projectParts.toString());
                    _this.precent(d.data.rate); //百分比
                    _this.firstParty(d.data.firstParty);
                    _this.secondparty(d.data.secondParty);
                    _this.cooperativeNature(d.data.cooperativeNature);
                    console.log(_this.sercontract());
                    if (d.data.beginTime) {
                        _this.beginTime(d.data.beginTime);
                    }
                    else {
                        _this.beginTime(undefined);
                    }
                    if (d.data.serviceTime) {
                        _this.serviceTime(d.data.serviceTime);
                    }
                    else {
                        _this.serviceTime(undefined);
                    }
                    if (d.data.signTime) {
                        _this.signTime(d.data.signTime);
                    }
                    else {
                        _this.signTime(undefined);
                    }
                    if (d.data.addSign && d.data.addSign == 1) {
                        _this.addSign(true);
                    }
                    else {
                        _this.addSign(false);
                    }
                    if (d.data.serviceList && d.data.serviceList.length) {
                        _this.givememoneymassage(d.data.serviceList);
                    }
                    else {
                        _this.givememoneymassage([{ ser: "", area: "", stands: "" }]);
                    }
                    if (d.data.depotList && d.data.depotList.length) {
                        _this.givememoneymassagetwo(d.data.depotList);
                    }
                    else {
                        _this.givememoneymassagetwo([{ stopcar: "", charge: "", chargest: "" }]);
                    }
                    _this.username([]);
                    if (d.data.extractList && d.data.extractList.length) {
                        for (var i in d.data.extractList) {
                            d.data.extractList[i].extiactmoney = ko.observable(d.data.extractList[i].extiactmoney);
                            d.data.extractList[i].name = ko.observable(d.data.extractList[i].name);
                            _this.username.push(d.data.extractList[i].name);
                        }
                        _this.allocationplan(d.data.extractList);
                    }
                    else {
                        _this.allocationplan([{ name: ko.observable(""), allocationpro: "", remark: "", extiactmoney: ko.observable(0) }]);
                    }
                    _this.yearchargeall(d.data.totalCharge);
                    _this.exchange(d.data.totalExtract);
                    if (d.data.uploadReportId && d.data.uploadReportId.length) {
                        _this.csfile(d.data.uploadReportId);
                        //   this.uploadReportId(d.data.uploadReportId.id);
                        for (var i in d.data.uploadReportId) {
                            _this.uploadReportId.push(d.data.uploadReportId[i].file_id);
                        }
                        //this.uploadReportId.push(d.data.uploadReportId.find((p:any)=>p.id));
                    }
                    else {
                        _this.csfile([]);
                    }
                    if (d.data.uploadScanId && d.data.uploadScanId.length) {
                        //this.uploadScanId(d.data.uploadScanId.id);
                        _this.fwfile(d.data.uploadScanId);
                        for (var i in d.data.uploadScanId) {
                            _this.uploadScanId.push(d.data.uploadScanId[i].file_id);
                        }
                    }
                    else {
                        _this.fwfile([]);
                    }
                    if (d.data.uploadExamineId && d.data.uploadExamineId.length) {
                        //  this.uploadExamineId(d.data.uploadExamineId.id);
                        _this.htfile(d.data.uploadExamineId);
                        for (var i in d.data.uploadExamineId) {
                            _this.uploadExamineId.push(d.data.uploadExamineId[i].file_id);
                        }
                        // this.uploadExamineId.push(d.data.uploadExamineId.find((p:any)=>p.id));
                    }
                    else {
                        _this.htfile([]);
                    }
                    _this.isMore('#csfile_id');
                    _this.isMore('#fwfile_id');
                    _this.isMore('#htfile_id');
                }
                console.log(_this.csfile());
                // this.csfile(d.data.file);
                // if(d.data.file[0]){
                //     this.uploadReportId(d.data.file[0].id);
                // }
                // if(d.data.file[1]){
                //   this.uploadReportId(d.data.file[1].id);
                // }
                // if(d.data.file[2]){
                //   this.uploadReportId(d.data.file[2].id);
                // }
                // ajax.deleteIt('/api/project/signform', { projectId: this.projectid() })
                //   .then((d) => {
                //     this.num(d.data.num);
                //   })
                //清空表单
                //   this.csfile.removeAll() //测算文件
                //   this.htfile.removeAll()//合同及盖章审批记录
                //   this.fwfile.removeAll()//服务合同扫描件
                //   this.qwpostName('');//搜出来的人员
                //   this.username(['']);//选中的参与人
                //   this.qwsearchnamevalue('');//搜索框值
                //   this.firstParty("");//合作甲方
                //   this.secondparty("");//乙方
                //   this.cooperativeNature();//合作性质
                //  // let div1 = document.getElementById("begintime") as HTMLInputElement;
                //   let div1=this.container.querySelector('#begintime') as HTMLInputElement;
                //   div1.value=''
                //   this.beginTime('');//项目进场时间
                //   let div2 =this.container.querySelector("#signtime") as HTMLInputElement;
                //   div2.value=''
                //   this.signTime()('');//签约时间
                //   let div3 =this.container.querySelector("#servicetime") as HTMLInputElement;
                //   div3.value=''
                //   this.serviceTime('');//合同服务期限
                //   this.addSign(false);//新增签约,提交提成分配方案
                //   this.givememoneymassage([{ ser: "", area: "", stands: "" }]); //收费信息1
                //   this.givememoneymassagetwo([{ stopcar: "", charge: "", chargest: "" }]);//收费信息2
                //   this.yearchargeall(0); //年收费总额
                //   this.exchange(0); //预计提成总额
                //   this.allocationplan([{ name: "", allocationpro: "", remark: "", extiactmoney: 0 }]);//提成分配方案
            });
            this.yeji(1);
        }
        return true;
    };
    //洽谈跟进收购表单
    HeaderModel.prototype.ShouGou = function (m, e) {
        var _this = this;
        this.investiagtionReport([]);
        this.auditReport([]);
        this.contractApproval([]);
        this.equityAgreement([]);
        this.projectfilename([]);
        this.auditreport([]);
        this.Contractandseal([]);
        this.agreement([]);
        this.showMore(false);
        this.Sallocationplan([{ name: ko.observable(''), Sallocationpro: "", Sremark: "", Sextiactmoney: ko.observable(0) }]); //收购表单提成分配方案
        if (this.isCan() == false) {
            return window.popBox.show('公式已过期');
        }
        this.cid(this.projectid());
        if (this.shougou() == 1) {
            this.shougou(0);
        }
        else {
            ajax.get("/api/project/excel", { projectId: this.projectid() })
                .then(function (d) {
                if (d.data) {
                    _this.projectName(d.data.projectName);
                    _this.sgPname(d.data.projectName);
                    _this.projectArea(d.data.projectArea);
                    _this.projectAddr(d.data.projectAddr);
                    _this.dbaddress(d.data.projectAddr);
                    _this.sercontract([]);
                    if (d.data.infoList != undefined) {
                        for (var n = 0; n < d.data.infoList.length; n++) {
                            _this.sercontract().push(d.data.infoList[n].contractName);
                        }
                    }
                    if (d.data.projectParts) {
                        _this.projectParts(d.data.projectParts.toString());
                    }
                    else {
                        _this.projectParts(undefined);
                    }
                    _this.holderList(d.data.holderList);
                    if (d.data.projectManager && d.data.projectManager == 1) {
                        _this.projectManager(true);
                    }
                    else {
                        _this.projectManager(false);
                    }
                    _this.money(d.data.rate);
                    if (d.data.signTime) {
                        _this.signTimes(d.data.signTime.split('T')[0]);
                    }
                    else {
                        _this.signTimes('');
                    }
                    if (d.data.exchangeRights) {
                        _this.exchangeRights(d.data.exchangeRights.split('T')[0]);
                    }
                    else {
                        _this.exchangeRights('');
                    }
                    if (d.data.infoList && d.data.infoList.length) {
                        _this.infoList(d.data.infoList);
                    }
                    else {
                        _this.infoList([{ communityName: "", builtArea: "", projectCity: "", contractService: "1" }]);
                    }
                    if (d.data.projectCount) {
                        _this.projectCount(d.data.projectCount);
                    }
                    else {
                        _this.projectCount(undefined);
                    }
                    if (d.data.totalExtract) {
                        _this.totalExtract(d.data.totalExtract);
                    }
                    else {
                        _this.totalExtract(0);
                    }
                    if (d.data.totalArea) {
                        _this.totalArea(d.data.totalArea);
                    }
                    else {
                        _this.totalArea(0);
                    }
                    if (d.data.extractList && d.data.extractList.length) {
                        for (var i in d.data.extractList) {
                            d.data.extractList[i].name = ko.observable(d.data.extractList[i].name);
                            d.data.extractList[i].Sextiactmoney = ko.observable(d.data.extractList[i].Sextiactmoney);
                        }
                        _this.Sallocationplan(d.data.extractList);
                    }
                    if (d.data.investiagtionReport && d.data.investiagtionReport.length) {
                        _this.projectfilename(d.data.investiagtionReport);
                        for (var i in d.data.investiagtionReport) {
                            _this.investiagtionReport.push(d.data.investiagtionReport[i].file_id);
                        }
                        //   this.investiagtionReport.push(d.data.investiagtionReport.find((p:any)=>p.id))
                        console.log(_this.investiagtionReport());
                        // this.investiagtionReport(d.data.investiagtionReport.id)
                    }
                    else {
                        _this.projectfilename([]);
                    }
                    console.log(_this.projectfilename());
                    if (d.data.auditReport) {
                        _this.auditreport(d.data.auditReport);
                        for (var i in d.data.auditReport) {
                            _this.auditReport.push(d.data.auditReport[i].file_id);
                        }
                        // this.auditReport.push(d.data.auditReport.find((p:any)=>p.id));
                    }
                    else {
                        _this.auditreport([]);
                    }
                    if (d.data.contractApproval) {
                        _this.Contractandseal(d.data.contractApproval);
                        //  this.contractApproval(d.data.contractApproval.id);
                        for (var i in d.data.contractApproval) {
                            _this.contractApproval.push(d.data.contractApproval[i].file_id);
                        }
                        //this.contractApproval.push(d.data.contractApproval.find((p:any)=>p.id));
                    }
                    else {
                        _this.Contractandseal([]);
                    }
                    if (d.data.equityAgreement) {
                        _this.agreement(d.data.equityAgreement);
                        // this.equityAgreement(d.data.equityAgreement.id);
                        for (var i in d.data.equityAgreement) {
                            _this.equityAgreement.push(d.data.equityAgreement[i].file_id);
                        }
                        //this.equityAgreement.push(d.data.equityAgreement.find((p:any)=>p.id));
                    }
                    else {
                        _this.agreement([]);
                    }
                    _this.isMore('#auditreport_id');
                    _this.isMore('#projectfilename_id');
                    _this.isMore('#Contractandseal_id');
                    _this.isMore('#agreement_id');
                }
                //  ajax.deleteIt('/api/project/signform', { projectId: this.projectid() })
                //      .then((d) => {
                //        this.num(d.data.num);
                //      });
                //      //清空数据
                //      let div4=this.container.querySelector('#exchangerights') as HTMLInputElement;
                //      div4.value='';
                //      this.exchangeRights('');//权益交割日
                //      let div5 =this.container.querySelector("#signtimes") as HTMLInputElement;
                //      div5.value='';
                //      this.signTimes('');//签约时间
                //      this.projectfilename.removeAll();//现场勘查报告或可行性分析报告
                //      this.auditreport.removeAll();//审计报告
                //      this.Contractandseal.removeAll()//收购合同及盖章审批记录
                //      this.agreement.removeAll()//股权转让协议或补充协议：
                //      this.postName('');//搜出来的人
                //      this.susername(['']);//选中的参与人值
                //      this.searchnamevalue('');//搜索框值
                //      this.projectCount("")
                //      this.communityCount(1)//项目个数
                //      this.infoList([{ communityName: "", builtArea: "", projectCity: "", contractService: "1" }])
                //      this.totalArea(0)
                //      this.totalExtract(0)
                //      this.Sallocationplan([{ name: "", Sallocationpro: "", Sremark: "", Sextiactmoney: 0 }])
            });
            this.shougou(1);
        }
    };
    HeaderModel.prototype.zkGengDuo = function (m, e) {
        var div = e.currentTarget.parentNode
            .nextElementSibling;
        if (!div.style.display || div.style.display == "block") {
            div.style.display = "none";
        }
        else {
            div.style.display = "block";
        }
    };
    HeaderModel.prototype.XiangXiZK = function (m, e) {
        var div = e.currentTarget.parentNode
            .nextElementSibling.nextElementSibling;
        var div1 = e.currentTarget.parentNode
            .nextElementSibling;
        var div2 = e.currentTarget.lastElementChild;
        if (!div.style.display || div.style.display == "none") {
            div1.style.display = "block";
            div.style.display = "block";
            div2.style.transform = "rotate(0deg)";
        }
        else {
            div1.style.display = "none";
            div.style.display = "none";
            div2.style.transform = "rotate(180deg)";
        }
    };
    HeaderModel.prototype.GenJin = function (m, e) {
        if (this.genjin() == 1) {
            this.genjin(0);
        }
        else {
            this.genjin(1);
        }
    };
    HeaderModel.prototype.Popur = function (m, e) {
        if (this.popur() == 1) {
            this.popur(0);
        }
        else {
            this.popur(1);
        }
    };
    HeaderModel.prototype.Popur1 = function (data, index, e) {
        this.peopleindex(index);
        if (this.popur1() == 1) {
            this.popur1(0);
            this.postName([]);
            this.searchnamevalue('');
        }
        else {
            this.popur1(1);
        }
    };
    HeaderModel.prototype.Popur2 = function (m, index, e) {
        this.peopleindex(index);
        if (this.popur2() == 1) {
            this.popur2(0);
            this.qwpostName([]);
            this.qwsearchnamevalue('');
        }
        else {
            this.popur2(1);
        }
    };
    HeaderModel.prototype.guanbi = function (m, e) {
        if (this.qunliao() == 1) {
            // this.data.pageIndex = 1;
            // this.data.userId = authorization.getUserId();
            // this.data.type = 1;
            // this.data.type2 = 0;
            // this.data.projectName = "";
            // this.loadData().then(()=>{
            // })
            this.qunliao(0);
        }
        else {
            this.qunliao(1);
        }
        // ajax.get("/api/project/pc/screen",{
        //   userId:authorization.getUserId(),
        //   pageIndex:1,
        //   type2:0,
        //   type:1,
        //   projectName:this.sprojectname()
        // })
    };
    //群聊
    HeaderModel.prototype.QunLiao = function (e, index, id) {
        var _this = this;
        if (e.projectGps == null || e.projectGps == 'null') {
            this.isCan(false);
        }
        else {
            this.isCan(true);
        }
        e.projectComment('0');
        // this.container.querySelector('#'+id).innerHTML = '0';
        if (e.projectOwner == null) {
            return window.popBox.show('该项目已关闭');
        }
        ajax.post("/api/message/date", { projectId: e.id, userId: window.localStorage.getItem("UserId") });
        this.mytime();
        this.projectid(e.id); //项目id
        this.pid(e.id);
        ajax.get("/api/project/details", { projectId: this.projectid() })
            .then(function (d) {
            if (d.data) {
                console.log(d.data.details);
                _this.info(d.data.details[0]);
                console.log(_this.info());
                // 控制项目阶段显示
                if (_this.info().projectOwner != authorization.getUsername()) {
                    _this.hiddenG(false);
                    _this.hiddenS(false);
                    _this.hiddenY(false);
                    _this.hiddenW(false);
                    _this.hiddenH(false);
                }
                else {
                    if (_this.info().projectStatus == "1") {
                        _this.hiddenG(true);
                        _this.hiddenS(false);
                        _this.hiddenY(false);
                        _this.hiddenW(false);
                        _this.hiddenH(false);
                    }
                    else if (_this.info().projectStatus == "2" &&
                        _this.info().cooperationMode == "股权合作") {
                        _this.hiddenS(true);
                        _this.hiddenG(false);
                        _this.hiddenY(false);
                        _this.hiddenW(false);
                        _this.hiddenH(false);
                    }
                    else if (_this.info().projectStatus == "2" &&
                        _this.info().cooperationMode != "股权合作") {
                        _this.hiddenY(true);
                        _this.hiddenG(false);
                        _this.hiddenS(false);
                        _this.hiddenW(false);
                        _this.hiddenH(false);
                    }
                    else if (_this.info().projectStatus == "3") {
                        _this.hiddenH(true);
                        _this.hiddenY(false);
                        _this.hiddenG(false);
                        _this.hiddenS(false);
                        _this.hiddenW(false);
                    }
                    else if (_this.info().projectStatus == "4") {
                        _this.hiddenH(false);
                        _this.hiddenY(false);
                        _this.hiddenG(false);
                        _this.hiddenS(false);
                        _this.hiddenW(true);
                    }
                }
            }
            else {
                _this.info(null);
            }
        })
            .then(function (d) {
            ajax.get("/api/user/chatMessage", { pid: _this.projectid(), userId: authorization.getUserId() })
                .then(function (d) {
                if (d.status == '0') {
                    if (d.data.messages.length > 0) {
                        _this.massage(d.data.messages);
                        _this.time(d.data.messages[0].chatDate.replace(/(\d{4}).(\d{1,2}).(\d{1,2}).(\d{1,2}).(\d{1,2}).(\d{1,2}).+/mg, '$1-$2-$3 $4:$5:$6'));
                    }
                    else {
                        _this.massage([]);
                    }
                    console.log(_this.massage());
                    if (_this.qunliao() == 1) {
                        _this.qunliao(0);
                    }
                    else {
                        _this.qunliao(1);
                        var chardiv = _this.container.querySelector('#msg_end');
                        chardiv.scrollIntoView();
                        var preview = new Preview({
                            imgWrap: 'Myproject_img' // 指定该容器里的图片点击预览
                        });
                    }
                }
            }).then(function (d) {
            });
        });
    };
    //回车发送
    HeaderModel.prototype.cksend = function (e, a, c) {
        if (a.keyCode == '13') {
            this.sendmsg();
        }
    };
    //发送消息
    HeaderModel.prototype.sendmsg = function () {
        var _this = this;
        if (this.chan().trim() == '') {
            this.chan('');
            return;
        }
        var type = 1;
        var userid = this.userId();
        var username = window.localStorage.getItem("Username");
        var proid = this.projectid();
        ajax.post("/api/user/chat", {
            message: this.chan(),
            type: type,
            project_id: proid,
            user_name: username,
            userId: userid
        }).then(function (d) {
            ajax.get("/api/user/chatMessage", { pid: _this.projectid() })
                .then(function (d) {
                _this.massage(d.data.messages);
                _this.time(d.data.messages[0].chatDate.replace(/(\d{4}).(\d{1,2}).(\d{1,2}).(\d{1,2}).(\d{1,2}).(\d{1,2}).+/gm, "$1-$2-$3 $4:$5:$6"));
                var chardiv = _this.container.querySelector('#msg_end');
                chardiv.scrollIntoView();
                // console.log(chardiv);
            });
            ajax.post('/api/message/date', {
                projectId: proid,
                userId: authorization.getUserId()
            });
            // this.data.pageIndex = 1;
            // this.data.userId = authorization.getUserId();
            // this.data.type = 1;
            // this.data.type2 = 0;
            // this.data.projectName = "";
            // this.loadData();
        });
        this.chan("");
    };
    HeaderModel.prototype.mytime = function () {
        var _this = this;
        var div = document.getElementById("Myproject");
        //this.data.pid = this.projectid();
        ajax.get("/api/user/chatMessage", { pid: this.projectid() })
            .then(function (d) {
            _this.massage(d.data.messages);
            if (d.data.messages != "")
                _this.time(d.data.messages[0].chatDate.replace(/(\d{4}).(\d{1,2}).(\d{1,2}).(\d{1,2}).(\d{1,2}).(\d{1,2}).+/gm, "$1-$2-$3 $4:$5:$6"));
        });
    };
    HeaderModel.prototype.QunLiaoX = function (m, e) {
        var div = e.currentTarget.lastElementChild;
        if (this.qunliaox() == 1) {
            this.qunliaox(0);
            div.style.transform = "rotate(180deg)";
        }
        else {
            this.qunliaox(1);
            div.style.transform = "rotate(0deg)";
        }
    };
    ///////////////////////////
    /////////////////////////////////////////全委表单
    //上传图片回调函数
    HeaderModel.prototype.ponUploaded = function (root, ds) {
        var _this = this;
        console.log(ds);
        if (ds.data) {
            window.popBox.show(ds.message);
            ajax.get("/api/user/chatMessage", { pid: this.projectid() })
                .then(function (d) {
                _this.massage(d.data.messages);
                if (d.data.messages != "")
                    _this.time(d.data.messages[0].chatDate.replace(/(\d{4}).(\d{1,2}).(\d{1,2}).(\d{1,2}).(\d{1,2}).(\d{1,2}).+/gm, "$1-$2-$3 $4:$5:$6"));
                var chardiv = _this.container.querySelector('#msg_end');
                chardiv.scrollIntoView();
            });
        }
        else {
            window.popBox.show('上传失败');
        }
        //上传图片成功后关闭弹窗
        if (this.genjin() == 1) {
            this.genjin(0);
        }
        else {
            this.genjin(1);
        }
    };
    //草稿
    HeaderModel.prototype.qwdraft = function () {
        var qdraft = window.localStorage;
        qdraft["qwprojectName"] = this.projectName(); //项目名
        qdraft["qwprojectAddr"] = this.projectAddr(); //项目地点
        qdraft["qwprojectArea"] = this.projectArea(); //项目面积
        qdraft["qwprojectParts"] = this.projectParts(); //已入伙面积
        qdraft["qwfirstParty"] = this.firstParty(); //甲方
        qdraft["qwsecondparty"] = this.secondparty(); //乙方
        qdraft["qwcooperativeNature"] = this.cooperativeNature(); //甲方
        qdraft["qwbeginTime"] = this.beginTime(); //进场时间
        qdraft["qwserviceTime"] = this.serviceTime(); //服务期限
        qdraft["qwsignTime"] = this.signTime(); //签约时间
        qdraft["qwgivememoneymassage"] = this.givememoneymassage(); //收费信息1
        qdraft["qwgivememoneymassagetwo"] = this.givememoneymassagetwo(); //收费信息2
        qdraft["qwyearchargeall"] = this.yearchargeall(); //年收费总额
        qdraft["qwallocationplan"] = this.allocationplan(); //提成分配方案
        window.history.back();
    };
    // //收费信息one增删
    HeaderModel.prototype.removemeonymassage = function (troot, tindex) {
        if (tindex == 0 && this.givememoneymassage().length == 1) {
            this.givememoneymassage([{ ser: "", area: "", stands: "" }]);
        }
        else {
            this.givememoneymassage.splice(tindex, 1);
            this.yearcharge();
        }
    };
    HeaderModel.prototype.addemeonymassage = function () {
        this.givememoneymassage.push({ ser: "", area: "", stands: "" });
    };
    // //收费信息two增删
    HeaderModel.prototype.removegivememoneymassagetwo = function (data, tindex) {
        if (tindex == 0 && this.givememoneymassagetwo().length == 1) {
            this.givememoneymassagetwo([{
                    stopcar: "",
                    charge: "",
                    chargest: ""
                }]);
        }
        else {
            this.givememoneymassagetwo.splice(tindex, 1);
            this.yearcharge();
        }
        //console.log(tindex)
    };
    HeaderModel.prototype.addgivememoneymassagetwo = function () {
        this.givememoneymassagetwo.push({ stopcar: "", charge: "", chargest: "" });
    };
    //分配方案增删
    HeaderModel.prototype.removeallocationplan = function (data, tindex) {
        if (tindex == 0 && this.allocationplan().length == 1) {
            this.allocationplan([{
                    name: ko.observable(""),
                    allocationpro: "",
                    remark: "",
                    extiactmoney: ko.observable(0)
                }]);
        }
        else {
            this.allocationplan.splice(tindex, 1);
        }
        console.log(this.allocationplan());
    };
    HeaderModel.prototype.addallocationplan = function () {
        //console.log('tindex')
        this.allocationplan.push({
            name: ko.observable(""),
            allocationpro: "",
            remark: "",
            extiactmoney: ko.observable(0)
        });
        console.log(this.allocationplan());
    };
    //年度收费总额跟预计总额计算
    HeaderModel.prototype.yearcharge = function () {
        var totalmoney = 0;
        var totalmoneytwo = 0;
        for (var i in this.givememoneymassage()) {
            var many = Number(this.givememoneymassage()[i].area) * Number(this.givememoneymassage()[i].stands) * 12;
            console.log('业态' + i + '价格：' + many);
            if (isNaN(many)) {
                many = 0;
            }
            totalmoney += many;
        }
        // this.yearchargeone(totalmoney);
        for (var j in this.givememoneymassagetwo()) {
            var many = Number(this.givememoneymassagetwo()[j].charge) * Number(this.givememoneymassagetwo()[j].chargest) * 12;
            console.log('停车' + j + '价格：' + many);
            if (isNaN(many)) {
                many = 0;
            }
            totalmoneytwo += many;
        }
        // this.yearchargetwo(totalmoneytwo);
        if (isNaN(this.yearchargetwo())) {
            this.yearchargetwo(0);
        }
        if (isNaN(this.yearchargeone())) {
            this.yearchargeone(0);
        }
        console.log(totalmoney + totalmoneytwo);
        //  let all: any = this.yearchargeone() + this.yearchargetwo();
        this.yearchargeall((totalmoney + totalmoneytwo).toFixed(2)); //
        var qw = (this.yearchargeall() * this.precent()).toFixed(2);
        this.exchange(qw);
        console.log(this.exchange());
        this.extiact();
    };
    HeaderModel.prototype.checkCount = function () {
        return true;
    };
    //全委提成金额计算
    HeaderModel.prototype.extiact = function () {
        var i = 0;
        for (var _i = 0, _a = this.allocationplan(); _i < _a.length; _i++) {
            var emoney = _a[_i];
            i++;
            //	console.log(i);
            var allocationplan = Number(emoney.allocationpro) / 100;
            console.log('aaaa:' + allocationplan);
            if (isNaN(allocationplan)) {
                allocationplan = 0;
            }
            if (isNaN(this.exchange())) {
                this.exchange(0);
            }
            emoney.extiactmoney(this.exchange() * allocationplan);
            //console.log(emoney.extiactmoney + '=======分配方案金额=====')
            if (emoney.extiactmoney() > 0) {
                emoney.extiactmoney(Number(emoney.extiactmoney()).toFixed(2));
                //console.log(emoney.extiactmoney + '=======分配方案金额=====')
            }
            if (this.allocationplan.length != 0) {
                this.allocationplan.splice(i, 1);
                this.allocationplan.push(emoney);
            }
        }
        this.allocationplan(this.allocationplan());
    };
    // //将搜索到的关注人放到input框
    HeaderModel.prototype.qwchosepeoplebtn = function (m, e) {
        if (this.popur2() == 1) {
            this.popur2(0);
            this.qwpostName([]);
            this.qwsearchnamevalue('');
        }
        else {
            this.popur2(1);
        }
    };
    //搜索分配人
    HeaderModel.prototype.qwsearchname = function () {
        var _this = this;
        if (this.qwsearchnamevalue().trim() == "") {
        }
        else {
            ajax.get("/api/ice/getuser", { name: this.qwsearchnamevalue() })
                .then(function (d) {
                _this.qwpostName(d.data);
            });
        }
    };
    HeaderModel.prototype.qwbtn_choose = function (username) {
        this.allocationplan()[this.peopleindex()].name(username);
        return true;
    };
    //是否显示更多
    HeaderModel.prototype.isMore = function (node) {
        var div = this.container.querySelector(node);
        console.log('aaaaaa:' + div.clientWidth);
        var width = div.parentElement.clientWidth - 240;
        console.log(width);
        if (div.clientWidth >= width) {
            div.nextElementSibling.classList.add('active');
        }
        else {
            div.nextElementSibling.classList.remove('active');
        }
    };
    //驳回 是否显示更多
    //文件上传
    //现场勘查报告文件上传回调
    HeaderModel.prototype.csonUploaded = function (ds) {
        var _this = this;
        console.log(this.cid());
        if (ds.message != '文件上传成功') {
            return window.popBox.show(ds.message);
        }
        if (this.csfile().length) {
            ds.data.forEach(function (p) {
                _this.csfile.push(p);
                _this.uploadReportId.push(p.file_id);
            });
        }
        else {
            this.csfile(ds.data);
            this.uploadReportId(ds.data.map(function (p) { return p.file_id; }));
        }
        window.popBox.show(ds.message);
        this.isMore('#csfile_id');
    };
    //现场勘查报告删除文件
    HeaderModel.prototype.csdelfile = function (data, index) {
        var _this = this;
        if (data.file_id == "" || data.file_id == undefined) {
        }
        else {
            ajax.get("/api/ice/deleteconfiles", { pid: this.proid(), account: authorization.getUserId(), ids: data.file_id })
                .then(function (d) {
                if (d.status == "0") {
                    if (d.message == '文件删除成功') {
                        _this.csfile.splice(index, 1);
                        _this.uploadReportId.splice(index, 1);
                        _this.isMore('#csfile_id');
                    }
                    window.popBox.show(d.message);
                    //   this.csfile(this.csfile());
                }
                else {
                    window.popBox.show("删除失败");
                }
            });
        }
    };
    //合同文件上传回调
    HeaderModel.prototype.htonUploaded = function (ds) {
        var _this = this;
        if (ds.message != '文件上传成功') {
            return window.popBox.show(ds.message);
        }
        if (this.htfile().length) {
            ds.data.forEach(function (p) {
                _this.htfile.push(p);
                _this.uploadExamineId.push(p.file_id);
            });
        }
        else {
            this.htfile(ds.data);
            this.uploadExamineId(ds.data.map(function (p) { return p.file_id; }));
        }
        window.popBox.show(ds.message);
        this.isMore('#htfile_id');
    };
    //合同删除文件
    HeaderModel.prototype.htdelfile = function (data, index) {
        var _this = this;
        if (data.file_id == "" || data.file_id == undefined) {
        }
        else {
            ajax.get("/api/ice/deleteconfiles", { pid: this.proid(), account: authorization.getUserId(), ids: data.file_id })
                .then(function (d) {
                if (d.status == "0") {
                    if (d.message == '文件删除成功') {
                        _this.htfile.splice(index, 1);
                        _this.uploadExamineId.splice(index, 1);
                        _this.isMore('#htfile_id');
                    }
                    window.popBox.show(d.message);
                }
                else {
                    window.popBox.show("删除失败");
                }
            });
        }
    };
    //服务文件上传回调
    HeaderModel.prototype.fwonUploaded = function (ds) {
        var _this = this;
        if (ds.message != '文件上传成功') {
            return window.popBox.show(ds.message);
        }
        if (this.fwfile().length) {
            ds.data.forEach(function (p) {
                _this.fwfile.push(p);
                _this.uploadScanId.push(p.file_id);
            });
        }
        else {
            this.fwfile(ds.data);
            this.uploadScanId(ds.data.map(function (p) { return p.file_id; }));
        }
        window.popBox.show(ds.message);
        this.isMore('#fwfile_id');
    };
    //服务删除文件
    HeaderModel.prototype.fwdelfile = function (data, index) {
        var _this = this;
        if (data.file_id == "" || data.file_id == undefined) {
        }
        else {
            ajax.get("/api/ice/deleteconfiles", { pid: this.proid(), account: authorization.getUserId(), ids: data.file_id })
                .then(function (d) {
                if (d.status == "0") {
                    if (d.message == '文件删除成功') {
                        _this.fwfile.splice(index, 1);
                        _this.uploadScanId.splice(index, 1);
                        _this.isMore('#fwfile_id');
                    }
                    window.popBox.show(d.message);
                }
                else {
                    window.popBox.show("删除失败");
                }
            });
        }
    };
    HeaderModel.prototype.delMore = function (data, index) {
        if (this.tyIndex() == 0) {
            this.uploadReportId.splice(index, 1);
        }
        if (this.tyIndex() == 1) {
            this.uploadExamineId.splice(index, 1);
        }
        if (this.tyIndex() == 2) {
            this.uploadScanId.splice(index, 1);
        }
        if (this.tyIndex() == 3) {
            this.investiagtionReport.splice(index, 1);
        }
        if (this.tyIndex() == 4) {
            this.auditReport.splice(index, 1);
        }
        if (this.tyIndex() == 5) {
            this.contractApproval.splice(index, 1);
        }
        if (this.tyIndex() == 6) {
            this.equityAgreement.splice(index, 1);
        }
        this.moreArr.splice(index, 1);
        window.popBox.show('删除成功');
    };
    HeaderModel.prototype.lookMore = function (index) {
        this.tyIndex(index);
        console.log(index);
        if (index == 0) {
            this.moreArr(this.csfile());
        }
        if (index == 1) {
            this.moreArr(this.htfile());
        }
        if (index == 2) {
            this.moreArr(this.fwfile());
        }
        if (index == 3) {
            this.moreArr(this.projectfilename());
        }
        if (index == 4) {
            this.moreArr(this.auditreport());
        }
        if (index == 5) {
            this.moreArr(this.Contractandseal());
        }
        if (index == 6) {
            this.moreArr(this.agreement());
        }
        console.log(this.moreArr());
        this.showMore(true);
    };
    HeaderModel.prototype.sureMore = function () {
        if (this.tyIndex() == 0) {
            this.csfile(this.moreArr());
            this.isMore('#csfile_id');
        }
        if (this.tyIndex() == 1) {
            this.htfile(this.moreArr());
            this.isMore('#htfile_id');
        }
        if (this.tyIndex() == 2) {
            this.fwfile(this.moreArr());
            this.isMore('#fwfile_id');
        }
        if (this.tyIndex() == 3) {
            this.projectfilename(this.moreArr());
            this.isMore('#projectfilename_id');
        }
        if (this.tyIndex() == 4) {
            this.auditreport(this.moreArr());
            this.isMore('#auditreport_id');
        }
        if (this.tyIndex() == 5) {
            this.Contractandseal(this.moreArr());
            this.isMore('#Contractandseal_id');
        }
        if (this.tyIndex() == 6) {
            this.agreement(this.moreArr());
            this.isMore('#agreement_id');
        }
        this.showMore(false);
    };
    // //进场时间
    HeaderModel.prototype.begintime = function () {
        var div = document.getElementById("begintime");
        this.beginTime(div.value);
    };
    //服务合同年限
    HeaderModel.prototype.servicetime = function () {
        var div = document.getElementById("servicetime");
        this.serviceTime(div.value);
    };
    //签约时间
    HeaderModel.prototype.signtime = function () {
        var div = document.getElementById("signtime");
        this.signTime(div.value);
        // console.log(this.signTime()+'==============签约时间')
    };
    //清除搜索关注人框数据
    HeaderModel.prototype.clearInput = function () {
        this.qwsearchnamevalue('');
        this.qwpostName(''); //搜出来的人
    };
    //全委表单提交
    HeaderModel.prototype.tijiao = function () {
        var _this = this;
        var informations = "";
        if (this.projectName() != null && this.projectName().length > 30) {
            informations = informations + "  项目名称过长<br>";
        }
        if (this.projectName().trim() == "") {
            informations = informations + "  项目名称未填写<br>";
        }
        if (this.projectAddr().trim() == "" || this.projectAddr() == undefined) {
            informations = informations + "  请输入项目详细地址 <br>";
        }
        // 项目名称查重
        if (this.qwPname().trim() != this.projectName().trim()) {
            this.checkProjectName();
        }
        // if(this.firstParty() == undefined || this.secondparty() == undefined){
        //   informations = informations + "合作主体信息不完整<br>"
        // }else{
        //   if(this.firstParty()!=undefined && this.secondparty()!=undefined){
        //     if (this.firstParty().trim() == "" && this.secondparty().trim() == "") {
        //       informations = informations + "合作主体信息不完整<br>"
        //     }else{
        //       if (this.firstParty().length > 30 || this.secondparty().length > 30) {
        //         informations = informations + "合作主体信息过长<br>"
        //       }
        //     }
        //   }else{
        //     informations = informations + "合作主体信息不完整<br>"
        //   }
        // }
        // 合作甲方
        if (this.firstParty() == undefined || this.firstParty() == '') {
            informations = informations + "甲方名称不能为空<br>";
        }
        if (this.firstParty() && this.firstParty().trim() == '') {
            informations = informations + "甲方名称不能为空<br>";
        }
        if (this.firstParty() && this.firstParty().trim().length > 30) {
            informations = informations + "甲方名称过长<br>";
        }
        // 合作乙方
        if (this.secondparty() == undefined || this.secondparty() == '') {
            informations = informations + "乙方名称不能为空<br>";
        }
        if (this.secondparty() && this.secondparty().trim() == '') {
            informations = informations + "乙方名称不能为空<br>";
        }
        if (this.secondparty() && this.secondparty().trim().length > 30) {
            informations = informations + "乙方名称过长<br>";
        }
        if (this.projectParts() == "") {
            informations = informations + "请输入已入伙面积!!<br>";
        }
        if (isNaN(Number(this.projectParts()))) {
            informations = informations + "  已入伙面积输入有误!!<br>";
        }
        if (this.projectParts().length > 12) {
            informations = informations + "已入伙面积太大<br>";
        }
        if (this.projectArea() == "") {
            informations = informations + "请输入总建筑面积<br>";
        }
        if (isNaN(Number(this.projectArea()))) {
            informations = informations + "总建筑面积输入有误<br>";
        }
        if (this.projectArea() && this.projectArea().length > 12) {
            informations = informations + "总建筑面积太大<br>";
        }
        var cover = parseFloat(this.projectArea());
        var join = parseFloat(this.projectParts());
        if (cover < join) {
            informations = informations + "入伙面积不得大于建筑面积<br>";
        }
        if (!this.signTime()) {
            informations = informations + "请选择签约时间<br>";
        }
        if (!this.beginTime()) {
            informations = informations + "请选择项目进场时间<br>";
        }
        if (!this.serviceTime()) {
            informations = informations + "请选择合同服务期限<br>";
        }
        console.log(this.signTime());
        //收费信息1
        var go = 0;
        for (var _i = 0, _a = this.givememoneymassage(); _i < _a.length; _i++) {
            var giveone = _a[_i];
            go = go + 1;
            if (giveone.ser == '') {
                informations = informations + "第" + go + "个业态未输入 <br>";
            }
            //业态可收费面积
            if (giveone.area == "") {
                informations = informations + "第" + go + "个业态可收费面积未输入<br>";
            }
            if (giveone.ser.length > 20) {
                informations = informations + "第" + go + "个业态名称过长<br>";
            }
            if (isNaN(Number(giveone.area))) {
                informations = informations + "第" + go + "个业态可收费面积有误<br>";
            }
            if (giveone.area.length > 12) {
                informations = informations + "第" + go + "个业态可收费面积过大<br>";
            }
            //业态收费标准
            if (giveone.stands == "") {
                informations = informations + "第" + go + "个业态收费标准未输入<br>";
            }
            if (isNaN(Number(giveone.stands))) {
                informations = informations + "第" + go + "个业态收费标准输入有误<br>";
            }
            if (giveone.stands.length > 10) {
                informations = informations + "第" + go + "个业态收费标准过大<br>";
            }
        }
        //收费信息2
        var gt = 0;
        for (var i in this.givememoneymassagetwo()) {
            gt += 1;
            if (this.givememoneymassagetwo()[i].stopcar == '') {
                informations = informations + "第" + gt + "个停车场未输入 <br>";
            }
            if (this.givememoneymassagetwo()[i].stopcar.length > 20) {
                informations = informations + "第" + gt + "个停车场名称过长 <br>";
            }
            //停车场收费个数
            if (this.givememoneymassagetwo()[i].charge == "" || this.givememoneymassagetwo()[i].charge == " ") {
                informations = informations + "第" + gt + "个停车场收费个数未输入<br>";
            }
            if (isNaN(Number(this.givememoneymassagetwo()[i].charge))) {
                informations = informations + "第" + gt + "个停车场收费个数有误<br>";
            }
            if (this.givememoneymassagetwo()[i].charge.length > 10) {
                informations = informations + "第" + gt + "个停车场收费个数过大<br>";
            }
            //停车场收费标准
            if (this.givememoneymassagetwo()[i].chargest == "" || this.givememoneymassagetwo()[i].chargest == ' ') {
                informations = informations + "第" + gt + "个停车场收费标准未输入<br>";
            }
            if (isNaN(Number(this.givememoneymassagetwo()[i].chargest))) {
                informations = informations + "第" + gt + "个停车场收费标准有误<br>";
            }
            if (this.givememoneymassagetwo()[i].chargest.length > 10) {
                informations = informations + "第" + gt + "个停车场收费标准过大<br>";
            }
        }
        //是否计算提成金额
        var b = 0;
        var addsign = 0;
        var fper = 0;
        if (this.addSign() == true) {
            addsign = 1;
            for (var _b = 0, _c = this.allocationplan(); _b < _c.length; _b++) {
                var all = _c[_b];
                b = b + 1;
                if (all.name == '') {
                    informations = informations + "第" + b + "个提成分配方案没有选择参与人<br>";
                }
                if (all.allocationpro == "" || all.allocationpro == "0") {
                    informations = informations + "第" + b + "个提成分配方案没有填写分配比例<br>";
                }
                else {
                    fper = Number(all.allocationpro) + fper;
                }
            }
            if (fper < 80) {
                informations = informations + "分配比例和应为80%<br>";
            }
            else if (fper > 80) {
                informations = informations + "分配比例之和超过80%<br>";
            }
            this.data.extractList = this.allocationplan(); //提成方案
        }
        else {
            addsign = 0;
        }
        //弹框提示
        if (informations.trim() != "") {
            window.popBox.show(informations);
            return;
        }
        //console.log(this.signTime()+'==============签约时间')
        ajax.post("/api/project/signform", {
            projectId: this.projectid(),
            userId: authorization.getUserId(),
            firstParty: this.firstParty(),
            secondParty: this.secondparty(),
            cooperativeNature: this.cooperativeNature(),
            beginTime: this.beginTime(),
            serviceTime: this.serviceTime(),
            signTime: this.signTime(),
            addSign: addsign,
            serviceList: this.givememoneymassage(),
            depotList: this.givememoneymassagetwo(),
            totalCharge: this.yearchargeall(),
            totalExtract: this.exchange(),
            extractList: this.allocationplan().map(function (p) { return _this.toJS(p); }),
            projectName: this.projectName(),
            projectAddr: this.projectAddr(),
            projectArea: this.projectArea(),
            projectParts: this.projectParts(),
            uploadReportId: this.uploadReportId(),
            uploadExamineId: this.uploadExamineId(),
            uploadScanId: this.uploadScanId(),
            num: this.num(),
        }).then(function () {
            //this.csfile([{ name: '' }])//测算文件
            _this.sprojectname('');
            _this.qunliao(0);
            _this.qunliaox(0);
            window.popBox.show("提交成功").then(function () {
                _this.data.pageIndex = 1;
                _this.data.userId = authorization.getUserId();
                _this.data.type = 1;
                _this.data.type2 = 0;
                _this.data.projectName = "";
                _this.load();
            });
        });
        //全委表单提交后关闭
        if (this.yeji() == 1) {
            this.yeji(0);
        }
        else {
            this.yeji(1);
        }
        return true;
    };
    ////////////////////////////////////////////////
    //////////////                                 收购表单
    // filename=ko.observableArray();
    //服务合同文件上传回调
    HeaderModel.prototype.onUploaded = function (data, index, ds) {
        if (ds.data != null) {
            // for(let i=0;i<ds.data.length;i++){
            //   this.infoList()[index].contractService = ds.data[i].file_id;
            //   this.sercontract()[index] = ds.data[i].file_name;
            //   this.sercontract(this.sercontract());
            // }
            this.infoList()[index].contractService = ds.data[0].file_id;
            this.sercontract()[index] = ds.data[0].file_name;
            this.sercontract(this.sercontract());
            // this.filename().push(ds.data[0].file_name);
            console.log('-----------文件名回显------------');
            console.log(this.sercontract()[0]);
        }
        window.popBox.show(ds.message);
    };
    //现场勘查报告文件上传回调
    HeaderModel.prototype.onUploadedtwo = function (ds) {
        var _this = this;
        console.log(ds);
        if (ds.message != '文件上传成功') {
            return window.popBox.show(ds.message);
        }
        if (this.projectfilename().length) {
            ds.data.forEach(function (p) {
                _this.projectfilename.push(p);
                _this.investiagtionReport.push(p.file_id);
            });
        }
        else {
            this.projectfilename(ds.data);
            this.investiagtionReport(ds.data.map(function (p) { return p.file_id; }));
        }
        window.popBox.show(ds.message);
        this.isMore('#projectfilename_id');
    };
    //现场勘查报告删除文件
    HeaderModel.prototype.delfile = function (data, index) {
        var _this = this;
        if (data.file_id == "" || data.file_id == undefined) {
        }
        else {
            ajax.get("/api/ice/deleteconfiles", {
                pid: this.proid(), account: authorization.getUserId(), ids: data.file_id
            })
                .then(function (d) {
                if (d.status == "0") {
                    if (d.message == '文件删除成功') {
                        _this.projectfilename.splice(index, 1);
                        _this.investiagtionReport.splice(index, 1);
                        _this.isMore('#projectfilename_id');
                    }
                    window.popBox.show(d.message);
                }
                else {
                    window.popBox.show("失败");
                }
            });
        }
    };
    //审计报告文件上传回调
    HeaderModel.prototype.onUploadedthree = function (ds) {
        var _this = this;
        if (ds.message != '文件上传成功') {
            return window.popBox.show(ds.message);
        }
        if (this.auditreport().length) {
            ds.data.forEach(function (p) {
                _this.auditreport.push(p);
                _this.auditReport.push(p.file_id);
            });
        }
        else {
            this.auditreport(ds.data);
            this.auditReport(ds.data.map(function (p) { return p.file_id; }));
        }
        window.popBox.show(ds.message);
        this.isMore('#auditreport_id');
    };
    //审计报告删除文件
    HeaderModel.prototype.delfilethree = function (data, index) {
        var _this = this;
        if (data.file_id == "" || data.file_id == undefined) {
        }
        else {
            ajax.get("/api/ice/deleteconfiles", { pid: this.proid(), account: authorization.getUserId(), ids: data.file_id })
                .then(function (d) {
                if (d.status == "0") {
                    if (d.message == '文件删除成功') {
                        _this.auditreport.splice(index, 1);
                        _this.auditReport.splice(index, 1);
                        _this.isMore('#auditreport_id');
                    }
                    window.popBox.show(d.message);
                }
                else {
                    window.popBox.show("失败");
                }
            });
        }
    };
    //收购合同及盖章文件上传回调
    HeaderModel.prototype.onUploadedfour = function (ds) {
        var _this = this;
        if (ds.message != '文件上传成功') {
            return window.popBox.show(ds.message);
        }
        if (this.Contractandseal().length) {
            ds.data.forEach(function (p) {
                _this.Contractandseal.push(p);
                _this.contractApproval.push(p.file_id);
            });
        }
        else {
            this.Contractandseal(ds.data);
            this.contractApproval(ds.data.map(function (p) { return p.file_id; }));
        }
        window.popBox.show(ds.message);
        this.isMore('#Contractandseal_id');
    };
    //收购合同及盖章删除文件
    HeaderModel.prototype.delfilefour = function (data, index) {
        var _this = this;
        if (data.file_id == "" || data.file_id == undefined) {
        }
        else {
            ajax.get("/api/ice/deleteconfiles", { pid: this.proid(), account: authorization.getUserId(), ids: data.file_id })
                .then(function (d) {
                if (d.status == "0") {
                    if (d.message == '文件删除成功') {
                        _this.Contractandseal.splice(index, 1);
                        _this.contractApproval.splice(index, 1);
                        _this.isMore('#Contractandseal_id');
                    }
                    window.popBox.show(d.message);
                }
                else {
                    window.popBox.show("失败");
                }
            });
        }
    };
    //股权转让协议文件上传回调
    HeaderModel.prototype.onUploadedfive = function (ds) {
        var _this = this;
        if (ds.message != '文件上传成功') {
            return window.popBox.show(ds.message);
        }
        if (this.agreement().length) {
            ds.data.forEach(function (p) {
                _this.agreement.push(p);
                _this.equityAgreement.push(p.file_id);
            });
        }
        else {
            this.agreement(ds.data);
            this.equityAgreement(ds.data.map(function (p) { return p.file_id; }));
        }
        window.popBox.show(ds.message);
        this.isMore('#agreement_id');
    };
    //股权转让协议删除文件
    HeaderModel.prototype.delfilefive = function (data, index) {
        var _this = this;
        if (data.file_id == "" || data.file_id == undefined) {
        }
        else {
            ajax.get("/api/ice/deleteconfiles", { pid: this.proid(), account: authorization.getUserId(), ids: data.file_id })
                .then(function (d) {
                if (d.status == "0") {
                    if (d.message == '文件删除成功') {
                        _this.agreement.splice(index, 1);
                        _this.equityAgreement.splice(index, 1);
                        _this.isMore('#agreement_id');
                    }
                    window.popBox.show(d.message);
                }
                else {
                    window.popBox.show("失败");
                }
            });
        }
    };
    //草稿
    HeaderModel.prototype.sgdraft = function () {
        var sdraft = window.localStorage;
        sdraft["sgprojectName"] = this.projectName(); //项目名
        sdraft["sgprojectAddr"] = this.projectAddr(); //项目地点
        sdraft["sgprojectArea"] = this.projectArea(); //项目面积
        sdraft["sgholderList"] = this.holderList(); //持股人
        sdraft["sgsignTime"] = this.signTime(); //签约时间
        sdraft["sgexchangeRights"] = this.exchangeRights(); //权益交割交割日
        sdraft["sgprojectCount"] = this.projectCount(); //项目数
        sdraft["sginfoList"] = this.infoList(); //项目资料
        sdraft["sgcommunityCount"] = this.communityCount(); //小区个数
        sdraft["sgtotalArea"] = this.totalArea(); //综合面积
        sdraft["sgtotalExtract"] = this.totalExtract(); //预计提成总额
        sdraft["sgSallocationplan"] = this.Sallocationplan(); //提成分配方案
    };
    // //将搜索dao的关注人放到input框
    HeaderModel.prototype.chosepeoplebtn = function (m, e) {
        //this.data={}
        this.username(this.username());
        if (this.popur1() == 1) {
            this.popur1(0);
            this.postName([]);
            this.searchnamevalue('');
        }
        else {
            this.popur1(1);
        }
    };
    //搜索分配人
    HeaderModel.prototype.searchname = function () {
        var _this = this;
        if (this.searchnamevalue().trim() == "") {
        }
        else {
            ajax.get("/api/ice/getuser", { name: this.searchnamevalue() })
                .then(function (d) {
                _this.postName(d.data);
            });
        }
    };
    HeaderModel.prototype.btn_choose = function (name) {
        var model = this.viewModel();
        this.Sallocationplan()[this.peopleindex()].name(name);
        console.log(this.Sallocationplan());
        return true;
    };
    //清除搜索关注人框数据
    HeaderModel.prototype.SclearInput = function () {
        this.searchnamevalue('');
        this.postName(''); //搜出来的人
    };
    //增删持股人
    HeaderModel.prototype.removeholderList = function (data, tindex) {
        if (tindex == 0 && this.holderList().length == 1)
            this.holderList([{ holderName: "", holderPercent: "" }]);
        else
            this.holderList.splice(tindex, 1);
    };
    HeaderModel.prototype.addemeholderListe = function () {
        this.holderList.push({ holderName: "", holderPercent: "" });
    };
    //签约时间
    HeaderModel.prototype.signtimes = function () {
        var div = document.getElementById("signtimes");
        this.signTimes(div.value);
    };
    //权限交割日
    HeaderModel.prototype.exchangerights = function () {
        var div = document.getElementById("exchangerights");
        this.exchangeRights(div.value);
    };
    //增删项目资料
    HeaderModel.prototype.removeinfoList = function (data, tindex) {
        if (tindex == 0 && this.infoList().length == 1)
            this.infoList([{
                    communityName: "",
                    builtArea: "",
                    projectCity: "",
                    contractService: "1"
                }]);
        else
            this.infoList.splice(tindex, 1);
        this.sercontract.splice(tindex, 1);
        this.communityCount(this.infoList().length);
        this.allarea();
    };
    HeaderModel.prototype.addinfoList = function () {
        this.infoList.push({
            communityName: "",
            builtArea: "",
            projectCity: "",
            contractService: "1"
        });
        this.communityCount(this.infoList().length);
    };
    //分配方案
    HeaderModel.prototype.removesallocationplan = function (data, tindex) {
        if (tindex == 0 && this.Sallocationplan().length == 1) {
            this.Sallocationplan([
                {
                    name: ko.observable(''),
                    Sallocationpro: "",
                    Sremark: "",
                    Sextiactmoney: ko.observable(0)
                }
            ]);
            return;
        }
        this.Sallocationplan.splice(tindex, 1);
        this.Sextiact();
    };
    HeaderModel.prototype.addsallocationplan = function () {
        this.Sallocationplan.push({
            name: ko.observable(''),
            Sallocationpro: "",
            Sremark: "",
            Sextiactmoney: ko.observable(0)
        });
    };
    //所有城市
    HeaderModel.prototype.allarea = function () {
        var totalmoney = 0;
        var totalmoneytwo = 0;
        for (var _i = 0, _a = this.infoList(); _i < _a.length; _i++) {
            var element = _a[_i];
            var many = Number(element.builtArea);
            if (isNaN(many)) {
                many = 0;
            }
            totalmoney = totalmoney + many;
        }
        this.totalArea(totalmoney);
        var xx = (this.totalArea() * this.money()).toFixed(2);
        this.totalExtract(xx);
        // this.totalExtract();
        this.Sextiact();
    };
    //收购提成分配计算
    HeaderModel.prototype.Sextiact = function () {
        var i = 0;
        for (var _i = 0, _a = this.Sallocationplan(); _i < _a.length; _i++) {
            var emoney = _a[_i];
            i++;
            // console.log(i);
            console.log(emoney);
            var allocationplan = Number(emoney.Sallocationpro) / 100;
            if (isNaN(allocationplan)) {
                allocationplan = 0;
            }
            if (isNaN(this.totalExtract())) {
                this.totalExtract(0);
            }
            emoney.Sextiactmoney(this.totalExtract() * allocationplan);
            // console.log(emoney.Sextiactmoney + '=======分配方案金额=====')
            if (emoney.Sextiactmoney() > 0) {
                emoney.Sextiactmoney(Number(emoney.Sextiactmoney()).toFixed(2));
                //console.log(emoney.Sextiactmoney + '=======分配方案金额=====')
            }
            if (this.Sallocationplan.length != 0) {
                this.Sallocationplan.splice(i, 1);
                this.Sallocationplan.push(emoney);
            }
        }
        this.Sallocationplan(this.Sallocationplan());
    };
    //收购表单提交
    HeaderModel.prototype.Stijiao = function () {
        var _this = this;
        var informations = "";
        if (this.projectName().trim() == "") {
            informations = informations + "项目名不能为空<br>";
        }
        if (this.projectAddr().trim() == "") {
            informations = informations + "项目地点不能为空<br>";
        }
        // 项目名查重
        if (this.sgPname().trim() != this.projectName().trim()) {
            this.checkProjectName();
        }
        //持股人验证
        var c = 0;
        var per = 0;
        for (var _i = 0, _a = this.holderList(); _i < _a.length; _i++) {
            var holderList = _a[_i];
            c = c + 1;
            if (holderList.holderName == '') {
                informations = informations + "第" + c + "个持股人没有填写姓名<br>";
            }
            if (holderList.holderPercent == '' || holderList.holderPercent == undefined || holderList.holderPercent == null) {
                informations = informations + "第" + c + "个持股数位空<br>";
            }
            else {
                per = Number(holderList.holderPercent) + per;
            }
        }
        if (per < 100) {
            informations = informations + "持股比例和应为100%<br>";
        }
        else if (per > 100) {
            informations = informations + "持股比例之和超过100<br>";
        }
        if (this.signTimes() == "") {
            informations = informations + "签约时间为空<br>";
        }
        if (this.exchangeRights() == "") {
            informations = informations + "权益交割日为空<br>";
        }
        if (this.projectArea() == "" || this.projectArea() == undefined) {
            informations = informations + "总建筑面积为空<br>";
        }
        if (isNaN(Number(this.projectArea()))) {
            informations = informations + "总建筑面积输入有误<br>";
        }
        if (this.projectArea() && this.projectArea().length > 12) {
            informations = informations + "总建筑面积太大<br>";
        }
        //项目个数验证
        if (this.projectCount() == "") {
            informations = informations + "项目个数不能为空<br>";
        }
        if ((isNaN(Number(this.projectCount())))) {
            informations = informations + "项目个数输入有误<br>";
        }
        if (this.projectCount() && this.projectCount().length > 10) {
            informations = informations + "项目个数太大<br>";
        }
        //项目资料验证
        var a = 0;
        for (var _b = 0, _c = this.infoList(); _b < _c.length; _b++) {
            var infoList = _c[_b];
            a = a + 1;
            if (infoList.contractService == "" || infoList.contractService == "1") {
                informations = informations + "第" + a + "个项目资料没有上传服务合同<br>";
            }
            if (infoList.communityName == "" || infoList.communityName == "1") {
                informations = informations + "第" + a + "个项目资料没有填写小区名称<br>";
            }
            if (infoList.builtArea == "" || infoList.builtArea == null || infoList.builtArea == undefined) {
                informations = informations + "第" + a + "个项目资料没有填写建筑面积㎡ <br>";
            }
            if ((isNaN(Number(infoList.builtArea)))) {
                informations = informations + "第" + a + "个建筑面积输入有误<br>";
            }
            if (infoList.builtArea.length > 12) {
                informations = informations + "第" + a + "个建筑面积过大<br>";
            }
            if (infoList.projectCity == "" || infoList.projectCity == "1") {
                informations = informations + "第" + a + "个项目资料没有填写项目所在城市<br>";
            }
        }
        for (var i = 0; i < this.infoList().length; i++) {
            if (this.infoList()[i].communityName.length > 20) {
                informations = informations + "第" + (Number(i) + 1) + "个小区名称过长<br>";
                //return window.popBox.show('第'+(i++)+'个小区名称过长')
            }
            if (this.infoList()[i].projectCity.length > 20) {
                informations = informations + "第" + (Number(i) + 1) + "个项目所在城市名称过长<br>";
                // return window.popBox.show('第'+(i+1)+'个项目所在城市名称过长')
            }
        }
        //提成分配方案验证
        var b = 0;
        var fper = 0;
        for (var _d = 0, _e = this.Sallocationplan(); _d < _e.length; _d++) {
            var all = _e[_d];
            b = b + 1;
            if (all.name() == '' || all.name() == '1') {
                informations = informations + "第" + b + "个提成分配方案没有选择参与人<br>";
            }
            if (all.Sallocationpro == "" || all.Sallocationpro == "1") {
                informations = informations + "第" + b + "个提成分配方案没有填写分配比例<br>";
            }
            else {
                fper = parseInt(all.Sallocationpro) + fper;
            }
        }
        if (fper < 80) {
            informations = informations + "分配比例和应为80%<br>";
        }
        else if (fper > 80) {
            informations = informations + "分配比例之和超过80%<br>";
        }
        //弹框提示
        if (informations.trim() != "") {
            return window.popBox.show(informations);
            ;
        }
        var projectManager = 0;
        if (this.projectManager()) {
            projectManager = 1;
        }
        else {
            projectManager = 0;
        }
        console.log(this.Sallocationplan());
        var sdaArr = [];
        for (var i in this.Sallocationplan()) {
            sdaArr.push({ name: this.Sallocationplan()[i].name(), Sallocationpro: this.Sallocationplan()[i].Sallocationpro, Sremark: this.Sallocationplan()[i].Sremark, Sextiactmoney: this.Sallocationplan()[i].Sextiactmoney() });
        }
        console.log(this.Sallocationplan());
        ajax.post("/api/project/signform", {
            projectId: this.projectid(),
            userId: authorization.getUserId(),
            signTime: this.signTimes(),
            exchangeRights: this.exchangeRights(),
            projectCount: this.projectCount(),
            communityCount: this.communityCount(),
            infoList: this.infoList(),
            totalArea: this.totalArea(),
            totalExtract: this.totalExtract(),
            extractList: sdaArr,
            num: this.num(),
            // projectfilename
            projectName: this.projectName(),
            projectAddr: this.projectAddr(),
            projectArea: this.projectArea(),
            projectManager: projectManager,
            holderList: this.holderList(),
            investiagtionReport: this.investiagtionReport(),
            auditReport: this.auditReport(),
            contractApproval: this.contractApproval(),
            equityAgreement: this.equityAgreement(),
        }).then(function () {
            _this.sprojectname('');
            _this.qunliao(0);
            _this.qunliaox(0);
            window.popBox.show("提交成功").then(function () {
                _this.data.pageIndex = 1;
                _this.data.userId = authorization.getUserId();
                _this.data.type = 1;
                _this.data.type2 = 0;
                _this.data.projectName = "";
                _this.load();
            });
        });
        if (this.shougou() == 1) {
            this.shougou(0);
        }
        else {
            this.shougou(1);
        }
    };
    //定位
    HeaderModel.prototype.location = function (m, d, e) {
        var mapgps;
        setTimeout(function () {
            // let div = document.getElementById("44444") ;
            mapgps = d.chatMessage.split(',');
            var map = new BMap.Map(e + 'dw' + '');
            map.centerAndZoom(new BMap.Point(mapgps[0], mapgps[1]), 16);
            map.addControl(new BMap.NavigationControl());
            map.addControl(new BMap.ScaleControl());
            map.addControl(new BMap.OverviewMapControl());
            map.addControl(new BMap.MapTypeControl());
            map.enableScrollWheelZoom(true);
            var new_point = new BMap.Point(mapgps[0], mapgps[1]);
            var marker = new BMap.Marker(new_point); // 创建标注
            map.addOverlay(marker); // 将标注添加到地图中
            map.panTo(new_point);
            var i = 16;
            map.addEventListener("click", function () {
                i = i + 1;
                mapgps = d.chatMessage.split(',');
                var map = new BMap.Map(e + 'dw');
                map.centerAndZoom(new BMap.Point(mapgps[0], mapgps[1]), i);
                map.enableScrollWheelZoom(true);
                var new_point = new BMap.Point(mapgps[0], mapgps[1]);
                var marker = new BMap.Marker(new_point); // 创建标注
                map.addOverlay(marker); // 将标注添加到地图中
                map.panTo(new_point);
            });
        }, 1000);
    };
    //根据时间排序
    //发起时间
    HeaderModel.prototype.straight = function () {
        //从高到低
        this.data = {};
        this.data.userId = authorization.getUserId();
        this.data.pageIndex = this.viewModel().data.pageIndex;
        this.data.type2 = 1;
        this.data.type = this.prostatus();
        this.data.projectName = this.sprojectname();
        this.loadData();
    };
    //点击下
    HeaderModel.prototype.inverted = function () {
        this.data = {};
        this.data.userId = authorization.getUserId();
        this.data.pageIndex = this.viewModel().data.pageIndex;
        this.data.type2 = 0;
        this.data.type = this.prostatus();
        this.data.projectName = this.sprojectname();
        this.loadData();
    };
    //最后跟进时间
    HeaderModel.prototype.zstraight = function () {
        //从高到低
        this.data = {};
        this.data.userId = authorization.getUserId();
        this.data.pageIndex = this.viewModel().data.pageIndex;
        this.data.type2 = 3;
        this.data.type = this.prostatus();
        this.data.projectName = this.sprojectname();
        this.loadData();
    };
    HeaderModel.prototype.zinverted = function () {
        //从低到高
        this.data = {};
        this.data.userId = authorization.getUserId();
        this.data.pageIndex = this.viewModel().data.pageIndex;
        this.data.type2 = 2;
        this.data.type = this.prostatus();
        this.data.projectName = this.sprojectname();
        this.loadData();
    };
    //项目进度排序
    HeaderModel.prototype.scheduleS = function () {
        //从高到低
        this.data = {};
        this.data.userId = authorization.getUserId();
        this.data.pageIndex = this.viewModel().data.pageIndex;
        this.data.type2 = 5;
        this.data.type = this.prostatus();
        this.data.projectName = this.sprojectname();
        this.loadData();
    };
    HeaderModel.prototype.scheduleJ = function () {
        //从低到高
        this.data = {};
        this.data.userId = authorization.getUserId();
        this.data.pageIndex = this.viewModel().data.pageIndex;
        this.data.type2 = 4;
        this.data.type = this.prostatus();
        this.data.projectName = this.sprojectname();
        this.loadData();
    };
    //建筑面积排序
    HeaderModel.prototype.areast = function () {
        //从高到低
        this.data = {};
        this.data.userId = authorization.getUserId();
        this.data.pageIndex = this.viewModel().data.pageIndex;
        this.data.type2 = 7;
        this.data.type = this.prostatus();
        this.data.projectName = this.sprojectname();
        this.loadData();
    };
    HeaderModel.prototype.areain = function () {
        //从低到高
        this.data = {};
        this.data.userId = authorization.getUserId();
        this.data.pageIndex = this.viewModel().data.pageIndex;
        this.data.type2 = 6;
        this.data.type = this.prostatus();
        this.data.projectName = this.sprojectname();
        this.loadData();
    };
    //搜索我的项目
    HeaderModel.prototype.serachproject = function () {
        this.data = {};
        this.data.userId = authorization.getUserId();
        this.data.pageIndex = 1;
        this.data.type2 = 0;
        this.data.type = this.prostatus();
        this.data.projectName = this.sprojectname();
        this.loadData();
    };
    //项目状态筛选
    HeaderModel.prototype.serachstus = function () {
        this.data = {};
        this.data.userId = authorization.getUserId();
        this.data.pageIndex = 1;
        this.data.type2 = 0;
        this.data.type = this.prostatus();
        this.data.projectName = this.sprojectname();
        this.loadData();
    };
    //编辑项目
    HeaderModel.prototype.editproject = function (m, e) {
    };
    HeaderModel.prototype.loadbubble = function () {
        var arr = [];
        console.log(parseInt(this.prostatus()) - 1);
        console.log(this.isSH());
        for (var i = 0; i < 7; i++) {
            if (this.prostatus() != undefined) {
                if (this.isSH() == false) {
                    if (parseInt(this.prostatus()) - 1 == i) {
                        localStorage.setItem((this.prostatus() - 1).toString(), new Date()["Format"]('yyyy-MM-dd hh:mm:ss'));
                        arr.push(new Date()["Format"]('yyyy-MM-dd hh:mm:ss'));
                        // if(i==6){
                        //   localStorage.setItem('6',new Date()["Format"]('yyyy-MM-dd hh:mm:ss'))
                        //   arr.push(new Date()["Format"]('yyyy-MM-dd hh:mm:ss'));
                        // }else{
                        //   arr.push(localStorage.getItem(i.toString()));
                        //  }
                        // }
                    }
                    else {
                        arr.push(localStorage.getItem(i.toString()));
                    }
                }
                else {
                    if (i == 6) {
                        localStorage.setItem('6', new Date()["Format"]('yyyy-MM-dd hh:mm:ss'));
                        arr.push(new Date()["Format"]('yyyy-MM-dd hh:mm:ss'));
                    }
                    else {
                        arr.push(localStorage.getItem(i.toString()));
                    }
                }
            }
            else {
                arr.push(localStorage.getItem(i.toString()));
            }
        }
        return ajax.post('/api/statistics/smessage', { userId: authorization.getUserId(), time: arr }).then(function (d) {
            ko.postbox.publish('leftMenu_myProject', d.data.count0);
            ko.postbox.publish('leftMenu_myFollowProject', d.data.count1);
            ko.postbox.publish('leftMenu_noFollowNews', d.data.count2);
            ko.postbox.publish('leftMenu_waitProjectNews', d.data.count3);
            ko.postbox.publish('leftMenu_signgedProjectNews', d.data.count4);
            ko.postbox.publish('leftMenu_abandonProjectNews', d.data.count5);
            ko.postbox.publish('leftMenu_auditMessage', d.data.count6);
        });
    };
    HeaderModel.prototype.loadnum = function () {
        return ajax.get('/api/statistics/message', { userid: authorization.getUserId(), loginTime: new Date()["Format"]('yyyy-MM-dd hh:mm:ss') }).then(function (d) {
            ko.postbox.publish('leftMenu_allProject', d.data.allProject);
            ko.postbox.publish('leftMenu_followProject', d.data.followProject);
            ko.postbox.publish('leftMenu_nofollow', d.data.nofollow);
            ko.postbox.publish('leftMenu_waitProject', d.data.waitProject);
            ko.postbox.publish('leftMenu_signgedProject', d.data.signgedProject);
            ko.postbox.publish('leftMenu_abandonProject', d.data.abandonProject);
            ko.postbox.publish('leftMenu_noReadProject', d.data.noReadProject);
        });
    };
    HeaderModel.prototype.load = function () {
        return Promise.all([this.loadnum(), this.loadbubble(), this.loadData()]).then(function () { });
    };
    HeaderModel.prototype.onViewModelSetting = function (d) {
        for (var i in d.data.list) {
            d.data.list[i].projectComment = ko.observable(d.data.list[i].projectComment);
        }
        return Promise.resolve(false);
    };
    HeaderModel.prototype.qwZK = function (m, e) {
        var div = e.currentTarget.parentNode.nextElementSibling;
        var div1 = e.currentTarget.firstElementChild;
        if (!div.style.display || div.style.display == "none") {
            div.style.display = 'block';
            div1.style.transform = 'rotate(180deg)';
        }
        else {
            div.style.display = 'none';
            div1.style.transform = 'rotate(0deg)';
        }
    };
    HeaderModel.prototype.ShouGouLook = function () {
        if (this.shougouLook() == 1) {
            this.project(undefined);
            this.shougouLook(0);
        }
        else {
            this.shougouLook(1);
        }
    };
    HeaderModel.prototype.QuanWeiLook = function () {
        if (this.quanweiLook() == 1) {
            this.quanweiLook(0);
        }
        else {
            this.quanweiLook(1);
        }
    };
    HeaderModel.prototype.edit = function (data) {
        var _this = this;
        console.log(data);
        // this.projectId(data.id)
        if (data.cooperationMode == '股权合作') {
            this.shougouLook(1);
            ajax.get("/api/audit", {
                projectId: data.id
            }).then(function (d) {
                _this.shougouInfo(d.data);
                _this.greason(d.data.reason);
            });
        }
        if (data.cooperationMode == '全委') {
            this.quanweiLook(1);
            ajax.get("/api/audit", {
                projectId: data.id
            }).then(function (d) {
                _this.quanweiInfo(d.data);
                console.log(_this.quanweiInfo());
                _this.sreason(d.data.reason);
            });
        }
    };
    // 收购表单现场勘察报告
    HeaderModel.prototype.sgXcFileUpload = function () {
        this.fileUploadNumber('现场勘察');
        if (this.popur4() == 1) {
            this.popur4(0);
        }
        else {
            this.popur4(1);
        }
    };
    // 收购表单审计报告
    HeaderModel.prototype.sgSjfile = function () {
        this.fileUploadNumber('审计报告');
        if (this.popur4() == 1) {
            this.popur4(0);
        }
        else {
            this.popur4(1);
        }
    };
    // 收购表单收购合同及盖章文件
    HeaderModel.prototype.sgHtFileUpload = function () {
        this.fileUploadNumber('收购合同及盖章审批记录');
        if (this.popur4() == 1) {
            this.popur4(0);
        }
        else {
            this.popur4(1);
        }
    };
    // 收购表单股权转让协议或补充协议
    HeaderModel.prototype.sgGbFileUpload = function () {
        this.fileUploadNumber('股权转让协议或补充协议');
        if (this.popur4() == 1) {
            this.popur4(0);
        }
        else {
            this.popur4(1);
        }
    };
    // 全委表单项目测算报告
    HeaderModel.prototype.qwXcFileUpload = function () {
        this.fileUploadNumber('项目测算报告');
        if (this.popur4() == 1) {
            this.popur4(0);
        }
        else {
            this.popur4(1);
        }
    };
    // 全委表单  合同及盖章审批记录
    HeaderModel.prototype.qwHgFileUpload = function () {
        this.fileUploadNumber('合同及盖章审批记录');
        if (this.popur4() == 1) {
            this.popur4(0);
        }
        else {
            this.popur4(1);
        }
    };
    // 全委  服务合同扫描件
    HeaderModel.prototype.qwFwFileUpload = function () {
        this.fileUploadNumber('服务合同扫描件');
        if (this.popur4() == 1) {
            this.popur4(0);
        }
        else {
            this.popur4(1);
        }
    };
    // 全委签约报备表单项目名称修改查重
    HeaderModel.prototype.checkProjectName = function () {
        var _this = this;
        // 项目名查重
        if (this.qwPname().trim() != this.projectName().trim()) {
            ajax.get("/api/project/name", {
                projectName: this.projectName()
            }).then(function (d) {
                if (d.status == "0") {
                    // e2.target.setAttribute("style", "border-color:green");
                }
            })
                .catch(function (e) {
                if (e.status == "22") {
                    // let node = e2.target as HTMLInputElement;
                    // node.setAttribute("style", "border-color:red");
                    return window.popBox.show("项目名重名").then(function () {
                        _this.projectName(_this.qwPname());
                    });
                }
            });
        }
    };
    // 收购签约报备表单项目名称修改查重
    HeaderModel.prototype.sgcheckProjectName = function () {
        var _this = this;
        if (this.sgPname().trim() != this.projectName().trim()) {
            ajax.get("/api/project/name", {
                projectName: this.projectName()
            }).then(function (d) {
                if (d.status == "0") {
                    // e2.target.setAttribute("style", "border-color:green");
                }
            })
                .catch(function (e) {
                if (e.status == "22") {
                    // let node = e2.target as HTMLInputElement;
                    // node.setAttribute("style", "border-color:red");
                    return window.popBox.show("项目名重名").then(function () {
                        _this.projectName(_this.sgPname());
                    });
                }
            });
        }
    };
    // 地点查重
    HeaderModel.prototype.checkProjectAdress = function () {
        var _this = this;
        if (this.projectAddr().split(',').length < 3) {
            return window.popBox.show('地点名称不完整');
        }
        if (this.projectAddr().split(',')[2] == '' || this.projectAddr().split(',')[2] == undefined) {
            return window.popBox.show('地点名称不完整');
        }
        if (this.projectAddr().split(',')[2].trim() == '') {
            return window.popBox.show('地点名称不完整');
        }
        if (this.dbaddress() != this.projectAddr().trim()) {
            ajax.get("/api/pc/addr", {
                projectAddr: this.projectAddr()
                // this.province() + "," + this.city() + "," + this.projectaddress()
            }).then(function (d) {
                if (d.status == "0") {
                    // e2.target.setAttribute("style", "border-color:green");
                }
            }).catch(function (e) {
                if (e.status == "22") {
                    // let node = e2.target as HTMLInputElement;
                    // node.setAttribute("style", "border-color:red");
                    window.popBox.show("详细地点重名").then(function () {
                        _this.projectAddr(_this.dbaddress());
                    });
                }
            });
        }
    };
    HeaderModel.prototype.checkProjectadressP = function () {
    };
    // 继续添加文件
    HeaderModel.prototype.fileChange = function (r, e) {
        this.hiddenBodyOne(false);
        this.hiddenBodytwo(true);
        this.hiddenX(true);
        // var  fd = new FormData();//提交文件
        var input = e.currentTarget;
        if ((this.fileList().length + input.files.length) > 10) {
            return window.popBox.show('一次最多上传10个文件!');
        }
        for (var i = 0; i < input.files.length; i++) {
            if (Number(input.files[i].size) > 10485760) {
                return window.popBox.show('单个文件不能超过10M');
            }
            // 判断重复文件
            for (var n = 0; n < this.fileList().length; n++) {
                if (this.fileList()[n].fileName == input.files[i].name) {
                    return window.popBox.show(input.files[i].name + '文件已存在!');
                }
            }
            if (i >= 10) {
                return window.popBox.show('一次最多上传10个文件!');
            }
            this.fileList.push({ 'fileName': input.files[i].name, 'fileLength': input.files[i].size });
            this.newFd().push(input.files.item(i)); //后台使用参数名file数组来获取所有上传文件
            // let fl: number = 0;
            if (this.fileList().length > 5) {
                var fs = this.container.querySelector('.file-zs');
                fs.style.height = '40%';
            }
        }
        // 清空input狂选择的文件
        var obj = this.container.querySelector('.fileUpload-inputOne');
        var obj1 = this.container.querySelector('.fileUpload-inputTwo');
        obj1.value = '';
        obj.value = '';
        // if(this.newFd()){
        // 	for(let n=0;n<this.newFd().getAll('file').length;n++){
        // 		fd.append('file',this.newFd().getAll('file')[n]);
        // 	}
        // }
        // this.newFd(fd);
        this.fileSize(0);
        var fl = 0;
        // 删除文件后文件数量以及总大小改变
        for (var h = 0; h < this.fileList().length; h++) {
            fl = fl + Number(this.fileList()[h].fileLength);
            this.fileSize(fl / 1024);
            if (this.fileSize() > 1024) {
                this.fileSize(fl / 1048576);
                var str = '选中' + this.fileList().length + '/10 个文件，共' + this.fileSize().toFixed(2) + 'M,单个文件大小限制:10.00M。';
                this.fileText(str);
            }
            else {
                var str = '选中' + this.fileList().length + '/10 个文件，共' + this.fileSize().toFixed(2) + 'K,单个文件大小限制:10.00M。';
                this.fileText(str);
            }
        }
        console.log(input.files);
    };
    // 上传文件
    HeaderModel.prototype.fileUploadBar = function () {
        var that = this;
        if (that.newFd().length < 1) {
            return window.popBox.show('未选择文件!');
        }
        else {
            this.hiddenBar(true);
            this.hiddenWord(false);
            this.hiddenX(false); //隐藏x号
            var xhr_1 = new XMLHttpRequest(); // XMLHttpRequest 对象
            var a_1 = 0;
            var fd = new FormData(); //提交文件
            for (var i = 0; i < that.newFd().length; i++) {
                fd.append("file", that.newFd()[i]);
            }
            fd.append("uid", window.localStorage.getItem('UserId')); //上传者账号
            fd.append("cid", this.cid()); //项目id点击的时候加载进来 this.cid()
            xhr_1.open("post", Configs.Configs.serviceUrl + '/api/ice/conupload', true); //post方式，url为服务器请求地址，true 该参数规定请求是否异步处理。
            xhr_1.upload.onprogress = function (ev) {
                //如果ev.lengthComputable为true就可以开始计算上传进度
                //上传进度 = 100* ev.loaded/ev.total
                if (ev.lengthComputable) {
                    var precent = 10 * ev.loaded / ev.total; //更改进度条，及百分比
                    var bar = that.container.querySelector('.file-bar-blue');
                    bar.style.width = precent + '%';
                    var percentText = (100 * ev.loaded / ev.total).toFixed(2);
                    var percentDiv = that.container.querySelector('.file-upload-word');
                    percentDiv.textContent = (Number(percentText) / 2).toFixed(2) + '%';
                    that.progressBar(precent);
                    if (a_1 == 0) {
                        var date1 = new Date(); //开始时间
                        that.stime(date1);
                    }
                    if (precent == 10) {
                        var date2 = new Date(); //结束时间
                        that.etime(date2);
                        var date3 = that.etime().getTime() - that.stime().getTime(); //时间差的毫秒数
                        that.localTime(date3);
                        var num = (that.localTime() / 100);
                        var ti = (num / 10);
                        if (ti > 10) {
                            ti = ti / 100;
                        }
                        that.progressFunction(num, ti, 400);
                    }
                    a_1++;
                }
            };
            // 开始上传
            xhr_1.send(fd);
            xhr_1.onreadystatechange = function (ev) {
                //readystate为2表示请求已完成并就绪
                if (ev.currentTarget.readyState == 0) {
                    that.hiddenWan(true);
                    return window.popBox.show('上传失败!');
                }
            };
            // 上传完成返回数据
            xhr_1.onload = function (ev) {
                that.hiddenBar(true);
                that.hiddenWord(false);
                var bar = that.container.querySelector('.file-bar-blue');
                bar.style.width = 25 + '%';
                var percentDiv = that.container.querySelector('.file-upload-word');
                percentDiv.textContent = 100 + '%';
                if (xhr_1.response) {
                    that.hiddenWan(true);
                    if (JSON.parse(xhr_1.response).status != '0') {
                        // that.hiddenWan(true);
                        return window.popBox.show('上传失败!');
                    }
                    else {
                        that.fileData(JSON.parse(xhr_1.response).data);
                        // console.log(that.fileData())
                        // 现场勘查上传文件调用组件
                        if (that.fileUploadNumber() == '现场勘察') {
                            if (that.projectfilename().length) {
                                that.fileData().forEach(function (p) {
                                    that.projectfilename.push(p);
                                    that.investiagtionReport.push(p.file_id);
                                });
                            }
                            else {
                                that.projectfilename(that.fileData());
                                that.investiagtionReport(that.fileData().map(function (p) { return p.file_id; }));
                            }
                            that.isMore('#projectfilename_id');
                        }
                        // 审计报告文件上传
                        if (that.fileUploadNumber() == '审计报告') {
                            if (that.auditreport().length >= 0) {
                                that.fileData().forEach(function (p) {
                                    that.auditreport.push(p);
                                    that.auditReport.push(p.file_id);
                                });
                            }
                            else {
                                that.auditreport(that.fileData());
                                that.auditReport(that.fileData().map(function (p) { return p.file_id; }));
                            }
                            that.isMore('#auditreport_id');
                        }
                        //  收购合同及盖章审批记录
                        if (that.fileUploadNumber() == '收购合同及盖章审批记录') {
                            if (that.Contractandseal().length) {
                                that.fileData().forEach(function (p) {
                                    that.Contractandseal.push(p);
                                    that.contractApproval.push(p.file_id);
                                });
                            }
                            else {
                                that.Contractandseal(that.fileData());
                                that.contractApproval(that.fileData().map(function (p) { return p.file_id; }));
                            }
                            that.isMore('#Contractandseal_id');
                        }
                        // 股权转让协议或补充协议
                        if (that.fileUploadNumber() == '股权转让协议或补充协议') {
                            if (that.agreement().length) {
                                that.fileData().forEach(function (p) {
                                    that.agreement.push(p);
                                    that.equityAgreement.push(p.file_id);
                                });
                            }
                            else {
                                that.agreement(that.fileData());
                                that.equityAgreement(that.fileData().map(function (p) { return p.file_id; }));
                            }
                            that.isMore('#agreement_id');
                        }
                        // 全委表单项目测算报告
                        if (that.fileUploadNumber() == '项目测算报告') {
                            if (that.csfile().length) {
                                that.fileData().forEach(function (p) {
                                    that.csfile.push(p);
                                    that.uploadReportId.push(p.file_id);
                                });
                            }
                            else {
                                that.csfile(that.fileData());
                                that.uploadReportId(that.fileData().map(function (p) { return p.file_id; }));
                            }
                            that.isMore('#csfile_id');
                        }
                        //全委表单 合同及盖章审批记录
                        if (that.fileUploadNumber() == '合同及盖章审批记录') {
                            if (that.htfile().length) {
                                that.fileData().forEach(function (p) {
                                    that.htfile.push(p);
                                    that.uploadExamineId.push(p.file_id);
                                });
                            }
                            else {
                                that.htfile(that.fileData());
                                that.uploadExamineId(that.fileData().map(function (p) { return p.file_id; }));
                            }
                            that.isMore('#htfile_id');
                        }
                        // 全委 服务合同扫描件
                        if (that.fileUploadNumber() == '服务合同扫描件') {
                            if (that.fwfile().length) {
                                that.fileData().forEach(function (p) {
                                    that.fwfile.push(p);
                                    that.uploadScanId.push(p.file_id);
                                });
                            }
                            else {
                                that.fwfile(that.fileData());
                                that.uploadScanId(that.fileData().map(function (p) { return p.file_id; }));
                            }
                            that.isMore('#fwfile_id');
                        }
                        return window.popBox.show('上传成功!');
                    }
                }
            };
        }
    };
    // 进度条百分比控制
    HeaderModel.prototype.progressFunction = function (num, ti, n) {
        var _this = this;
        if (num < 0) {
            return; //函数结束条件
        }
        console.log(num + '=========num=======');
        if (num < 3 && Number(this.fileSize().toFixed(2)) < 1024) {
            num = 10;
            n = 200;
        }
        if (num >= 20 && num < 50) {
            num = 20;
            n = 800;
        }
        // 大文件上传处理
        if (num >= 50) {
            num = 60;
            n = 800;
        }
        if (!this.hiddenWan()) {
            var bar = this.container.querySelector('.file-bar-blue');
            if (this.progressBar() < 25) {
                bar.style.width = this.progressBar() + ti + '%';
                var percentDiv = this.container.querySelector('.file-upload-word');
                percentDiv.textContent = (Number(this.progressBar() * 4) + Number(ti)).toFixed(2) + '%';
                num--;
                if (Number(this.progressBar() * 4) + Number(ti) < 100) {
                    percentDiv.textContent = (Number(this.progressBar() * 4) + Number(ti)).toFixed(2) + '%';
                }
                num--;
                this.progressBar(this.progressBar() + ti);
                if (num > 20) {
                    ti = (num / 300);
                }
                else {
                    ti = (num / 20);
                }
                setTimeout(function () {
                    _this.progressFunction(num, ti, n);
                }, n);
            }
        }
    };
    // 删除选中的某个文件
    HeaderModel.prototype.deleteFileUpload = function (r, e) {
        // console.log(e.fileName)
        for (var i = 0; i < this.fileList().length; i++) {
            if (e.fileName == this.fileList()[i].fileName) {
                this.fileList().splice(i, 1);
            }
        }
        this.fileList(this.fileList());
        // console.log(this.fileList())
        var arr1 = this.newFd(); //.getAll('file')
        for (var n = 0; n < this.newFd().length; n++) {
            var file = this.newFd()[n];
            if (e.fileName == file.name) {
                // fd.getAll('file').splice(n,1)
                arr1.splice(n, 1);
                arr1 = arr1;
                this.newFd([]);
                for (var m = 0; m < arr1.length; m++) {
                    this.newFd().push(arr1[m]);
                }
            }
        }
        this.fileSize(0);
        var fl = 0;
        if (this.fileList().length == 0) {
            var str = '选中 0/10 个文件，共0M,单个文件大小限制:10.00M。';
            this.fileText(str);
        }
        // 删除文件后文件数量以及总大小改变
        for (var h = 0; h < this.fileList().length; h++) {
            fl = fl + Number(this.fileList()[h].fileLength);
            this.fileSize(fl / 1024);
            if (this.fileSize() > 1024) {
                this.fileSize(fl / 1048576);
                var str = '选中' + this.fileList().length + '/10 个文件，共' + this.fileSize().toFixed(2) + 'M,单个文件大小限制:10.00M。';
                this.fileText(str);
            }
            else {
                var str = '选中' + this.fileList().length + '/10 个文件，共' + this.fileSize().toFixed(2) + 'K,单个文件大小限制:10.00M。';
                this.fileText(str);
            }
        }
        if (this.fileList().length <= 5) {
            var fs = this.container.querySelector('.file-zs');
            fs.style.height = '30%';
        }
        // console.log(fd.getAll('file'))
    };
    //确定
    HeaderModel.prototype.sureCk = function () {
        // 清空input狂选择的文件
        var obj = this.container.querySelector('.fileUpload-inputOne');
        var obj1 = this.container.querySelector('.fileUpload-inputTwo');
        obj1.value = '';
        obj.value = '';
        var str = '选中 0/10 个文件，共0M,单个文件大小限制:10.00M。';
        this.fileText(str);
        console.log(obj);
        this.fileData([]);
        this.fileList([]);
        this.hiddenBodyOne(true);
        this.hiddenBodytwo(false);
        this.hiddenWord(true);
        this.hiddenBar(false);
        this.hiddenWan(false);
        // fd.delete('file');
        // fd.delete('cid');
        // fd.delete('uid');
        this.newFd([]);
        var bar = this.container.querySelector('.file-bar-blue');
        bar.style.width = '0%';
        var percentDiv = this.container.querySelector('.file-upload-word');
        percentDiv.textContent = '0%';
        var fs = this.container.querySelector('.file-zs');
        fs.style.height = '30%';
        // 更新数据
        // this.data = {};
        // this.data.fid = this.saveFolderNameId();
        // this.data.userId = authorization.getUserId();
        // this.loadData();
        if (this.popur4() == 1) {
            this.popur4(0);
        }
        else {
            this.popur4(1);
        }
    };
    // 点击叉号关闭
    HeaderModel.prototype.closeFileUpload = function () {
        // 清空input狂选择的文件
        var obj = this.container.querySelector('.fileUpload-inputOne');
        var obj1 = this.container.querySelector('.fileUpload-inputTwo');
        obj1.value = '';
        obj.value = '';
        var str = '选中 0/10 个文件，共0M,单个文件大小限制:10.00M。';
        this.fileText(str);
        this.fileData([]);
        this.fileList([]);
        this.hiddenBodyOne(true);
        this.hiddenBodytwo(false);
        this.hiddenWord(true);
        this.hiddenBar(false);
        this.hiddenWan(false);
        this.newFd([]);
        // fd.delete('file');
        // fd.delete('cid');
        // fd.delete('uid');
        var bar = this.container.querySelector('.file-bar-blue');
        bar.style.width = '0%';
        var percentDiv = this.container.querySelector('.file-upload-word');
        percentDiv.textContent = '0%';
        var fs = this.container.querySelector('.file-zs');
        fs.style.height = '30%';
        // 更新数据
        // this.data = {};
        // this.data.fid = this.saveFolderNameId();
        // this.data.userId = authorization.getUserId();
        // this.loadData();
        if (this.popur4() == 1) {
            this.popur4(0);
        }
        else {
            this.popur4(1);
        }
    };
    HeaderModel.prototype.ExportChose = function (res, index) {
        if (this.choose_index.indexOf(index) == -1) {
            this.choose_index.push(index);
        }
        else {
            this.choose_index.remove(index);
        }
        return true;
    };
    // ie设置
    HeaderModel.prototype.ieS = function () {
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
        var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
        if (isIE) {
            var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
            reIE.test(userAgent);
            var fIEVersion = parseFloat(RegExp["$1"]);
            if (fIEVersion == 7) {
                return true;
            }
            else if (fIEVersion == 8) {
                return true;
            }
            else if (fIEVersion == 9) {
                return true;
            }
            else if (fIEVersion == 10) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    //用户管理全选
    HeaderModel.prototype.btn_choose_all = function (event) {
        var vm = this.viewModel();
        // debugger;
        if (this.ieS()) {
            if (event.srcElement.checked) {
                for (var i in vm.data.list) {
                    if (this.choose_index.indexOf(vm.data.list[i].id < 1)) {
                        this.choose_index.push(vm.data.list[i].id);
                    }
                }
            }
            else {
                this.choose_index.removeAll();
            }
        }
        else {
            if (event.target.checked) {
                // this.choose_index.removeAll();
                for (var i in vm.data.list) {
                    if (this.choose_index.indexOf(vm.data.list[i].id < 1)) {
                        this.choose_index.push(vm.data.list[i].id);
                    }
                }
            }
            else {
                this.choose_index.removeAll();
            }
        }
        return true;
    };
    // 导出excel
    HeaderModel.prototype.exportExcel = function () {
        if (this.choose_index().length < 1) {
            return window.popBox.show('至少选择一个项目');
        }
        console.log(this.choose_index());
        var str = '';
        for (var i = 0; i < this.choose_index().length; i++) {
            if (i < 1) {
                str = this.choose_index()[0];
            }
            else {
                str = str + ',' + this.choose_index()[i];
            }
        }
        window.open(Configs.Configs.serviceUrl + '/api/supplement/export?id=' + str);
    };
    return HeaderModel;
}(KnockoutModel));
var mModel = /** @class */ (function (_super) {
    __extends(mModel, _super);
    function mModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    mModel.prototype.init = function () {
        this.hm = new HeaderModel(this.container);
        //this.hm.bind();
    };
    mModel.prototype.update = function (arg) {
        //  ajax.get('/api/type/goal',{uid:authorization.getUserId()})
        //  .then((d)=>{
        //    this.hm.money(d.data.money);//钱数
        //    this.hm.precent(d.data.precent);//百分比
        //    console.log(this.hm.precent()+'==========百分比=========='+this.hm.money());
        //  })
        //首页跳转
        this.hm.choose_index([]);
        // console.log('type:' + arg.routeData.query.type)
        // console.log(typeof arg.routeData.query.type)
        if (arg.routeData.query.type != undefined) {
            if (arg.routeData.query.type == 10) {
                this.hm.isSH(true);
                this.hm.prostatus(1);
            }
            else {
                this.hm.isSH(false);
                this.hm.prostatus(arg.routeData.query.type);
            }
            this.hm.userid(authorization.getUserId());
            this.hm.userId(window.localStorage.getItem("UserId")); //用户id
            this.hm.data.pageIndex = 1;
            this.hm.data.type2 = 2;
            this.hm.data.userId = this.hm.userId;
            this.hm.data.type = this.hm.prostatus();
            this.hm.data.projectName = this.hm.sprojectname();
            console.log('有值并赋予:' + this.hm.prostatus());
            return this.hm.load();
        }
        else {
            this.hm.prostatus(undefined);
        }
        this.hm.pstatus([]);
        this.hm.pstatus([{ id: 1, text: "全部" }, { id: 7, text: "我负责" }, { id: 2, text: "我关注" }, { id: 3, text: "未跟进" }, { id: 4, text: "确认中" }, { id: 5, text: "已签约" }, { id: 6, text: "已放弃" }]);
        this.hm.sprojectname("");
        this.hm.userid(authorization.getUserId());
        this.hm.userId(window.localStorage.getItem("UserId")); //用户id
        this.hm.data.pageIndex = 1;
        this.hm.data.userId = authorization.getUserId();
        this.hm.data.type = 1;
        this.hm.data.type2 = 2;
        this.hm.data.projectName = "";
        //系统日志
        ajax.post('/api/log/add', { userId: authorization.getUserId(), logMessage: "我的项目" });
        return this.hm.load();
    };
    return mModel;
}(Page));
export default mModel;
